// 页面顶部搜索
module.exports = {
  // 报表编码
  reportCode: '报表编码',
  // 报表名称
  reportName: '报表名称',
  // 数据库属性
  databaseProperties: '数据库属性',
  // 页面属性
  pageProperties: '页面属性',
  // 校验字段
  checkField: '校验字段',
  // 外键
  foreignKey: '外键',
  // 索引
  index: '索引',
  // 查询配置
  queryConfiguration: '查询配置',
  // 树表单父ID
  treeFormParentId: '树表单父ID',
  // 是否有子节点字段
  IsAChildNodeField: '是否有子节点字段',
  // 树开表单列
  treeOpenFormColumn: '树开表单列',
  // 表单编码
  formEncoding: '表单编码',
  // 显示复选框
  showCheckbox: '显示复选框',
  // 是否分页
  isPaginate: '是否分页',
  // 是否树
  isTree: '是否树',
  // 主题模板
  themeTemplate: '主题模板',
  // 表单风格
  formStyle: '表单风格',
  // 移动表单风格
  mobileFormStyle: '移动表单风格',
  // 滚动条
  scrollBar: '滚动条',
  // 表单分类
  formClassification: '表单分类',
  // 主键策略
  primaryKeyStrategy: '主键策略',
  // 使用表单设计
  useFormDesign: '使用表单设计',
  // 序号名称
  serialNumberName: '序号名称',
  // 一对多
  oneToMany: '一对多',
  // 一对一
  oneOnOne: '一对一',
  // 单表
  singleTable: '单表',
  // 主表
  primaryTable: '主表',
  // 附表
  schedule: '附表',
  // 请输入类型函数转换
  pleaseEnter: '请输入{field}',
  // 请选择类型函数转换
  pleaseSelect: '请输入{field}',
  // 表名
  tableName: '表名',
  // 表类型
  tableType: '表类型',
  // 表描述
  tableDescription: '表描述',
  openMethod: '打开方式',
  customer: '客户',
  supplier: '供应商',
  ThisItemIsRequired: '该项为必填',
  PleaseSelectSynchronizationBusinessType: '请选择同步业务类型',
  PleaseSelectModificationStartDate: '请选择修改开始日期',
  PleaseSelectModificationEndDate: '请选择修改结束日期',
  head: '标题',
  pleaseEnterHead: '请输入标题',
  messageType: '消息类型',
  notificationType: '通告类型',
  pleaseChooseNotificationType: '请选择通告类型',
  pleaseChooseMessageType: '请选择消息类型',
  publisher: '发布人',
  designatedUser: '指定用户',
  pleaseChooseDesignatedUser: '请选择指定用户',
  allUser: '全体用户',
  notice: '通知公告',//通知公告
  systemMessage: '系统消息',//系统消息
  low: '低',//低
  middle: '中',//中
  high: '高',//高
  abstract: '摘要',
  pleaseEnterAbstract: '请输入摘要',
  priority: '优先级',
  content: '内容',
  pleaseChoosePriority: '请选择优先级',
  notificationObject: '通告对象',
  releaseStatus: '发布状态',
  releaseTime: '发布时间',
  startTime: '开始时间',
  pleaseChooseStartTime: '请选择开始时间',
  endTime: '结束时间',
  pleaseChooseEndTime: '请选择结束时间',
  cancellationTime: '撤销时间',
  factory: '工厂', // 工厂
  businessPartners: '业务伙伴', // 业务伙伴
  serialNo: '序号',//序号
  pleaseEnterSerialNo: '请输入序号',//请输入序号
  periodCode: '期间代码',//期间代码
  pleaseEnterPeriodCode: '请输入期间代码',//请输入期间代码
  startDate: '开始日期', // 开始日期
  pleaseSelectStartDate: '请选择开始日期',//请选择开始日期
  endDate: '结束日期', // 结束日期
  pleaseSelectEndDate: '请选择结束日期',//请选择结束日期
  lockedStatus: '锁定状态', // 锁定状态
  company: '公司', // 公司
  pleaseSelectCompany: '请选择公司', // 请选择公司
  periodCode: '账期',//账期
  alreadySelect: '已选',//已选
  pleaseSelectPeriod: '请选择账期',//请选择账期
  pleaseEnterPeriod: '请输入账期代码',//请输入账期
  pleaseSelectType: '请选择类型',//请选择类型
  isProductionCost: '是否生产成本',//是否生产成本
  details: '明细',//明细
  serviceDepartmentOrFarm: '服务部或农场', // 服务部或农场
  pleaseSelectServiceDepartmentOrFarm: '请选择服务部或农场', // 请选择服务部或农场
  documentDate: '单据日期', // 单据日期
  pleaseSelectDocumentDate: '请选择单据日期', // 请选择单据日期
  documentType: '单据类型', // 单据类型
  pleaseSelectDocumentType: '请选择单据类型', // 请选择单据类型
  documentStatus: '单据状态', // 单据状态
  pleaseSelectDocumentStatus: '请选择单据状态', // 请选择单据状态
  documentNumber: '单据编号', // 单据编号
  enterTheDocumentNumberForFuzzyQuery: '输入单据编号模糊查询', // 输入单据编号模糊查询
  warehouse: '仓库', // 仓库
  pleaseSelectWarehouse: '请选择仓库', // 请选择仓库
  requestFormMode: '申请单模式', // 申请单模式
  pleaseSelectRequestFormMode: '请选择申请单模式', // 请选择申请单模式
  sectionAssignmentCategory: '科目分配类别', // 科目分配类别
  pleaseSelectSectionAssignmentCategory: '请选择科目分配类别', // 请选择科目分配类别
  supplierCode: '供应商编码', // 供应商编码
  pleaseSelectSupplierCode: '请选择供应商编码', // 请选择供应商编码
  supplierName: '供应商名称', // 供应商名称
  pleaseEnterSupplierName: '请输入供应商名称', // 请输入供应商名称
  demandDate: '需求日期', // 需求日期
  pleaseSelectTheDemandDate: '请选择需求日期', // 请选择需求日期
  requestedArrivalDate: '要求到货日期', // 要求到货日期
  pleaseSelectRequestedArrivalDate: '请选择要求到货日期', // 请选择要求到货日期
  requisitioner: '请购员', // 请购员
  pleaseSelectRequisitioner: '请选择请购员', // 请选择请购员
  billingDate: '单据日期', // 单据日期
  pleaseSelectTheBillDate: '请选择单据账期', // 请选择单据账期
  remarks: '备注', // 备注
  pleaseEnterANote: '请输入备注', // 请输入备注
  contractCode: '合同编码', // 合同编码
  pleaseEnterTheContractCode: '请输入合同编码', // 请输入合同编码
  billingStatus: '单据类型', // 单据类型
  pleaseSelectBillingStatus: '请选择单据类型', // 单据类型
  receiptNumber: '入库单号', // 入库单号
  enterTheIncomingBillNumberToFuzzySearch: '输入入库单号模糊查询', // 输入入库单号模糊查询
  inboundWarehouse: '入库仓库', // 入库仓库
  warehouseLocation: '库位', // 库位
  purchaseContractNumber: '采购合同号', // 采购合同号
  pleaseEnterThePurchaseContractNumber: '请输入采购合同号', // 请输入采购合同号
  postingDate: '过账日期', // 过账日期
  pleaseSelectTheDateOfPosting: '请选择过账日期', // 请选择过账日期
  licensePlateNumber: '车牌号', // 车牌号
  pleaseEnterTheLicensePlateNumber: '请输入车牌号', // 请输入车牌号
  orderNumber: '订单编号', // 订单编号
  pleaseEnterOrderNumber: '请输入订单编号', // 请输入订单编号
  farm: '农场', // 农场
  pleaseSelectFarm: '请选择农场', // 请选择农场
  transferOutFarm: '转出农场', // 转出农场
  pleaseSelectTransferOutFarm: '请选择转出农场', // 请选择转出农场
  customerCode: '客户编码', // 客户编码
  pleaseSelectTheCustomerCode: '请选择客户编码', // 请选择客户编码
  customerName: '客户名称', // 客户名称
  pleaseEnterTheCustomerName: '请输入客户名称', // 请输入客户名称
  transferToFarm: '转入农场', // 转入农场
  pleaseSelectTheFarmToBeTransferredTo: '请选择转入农场', // 请选择转入农场
  requestedDateOfShipment: '要求发货日期', // 要求发货日期
  pleaseSelectTheRequestedDateOfShipment: '请选择要求发货日期', // 请选择要求发货日期
  salesman: '销售员', // 销售员
  outgoingFarm: '出库农场', // 出库农场
  pleaseSelectTheOutgoingFarm: 'please select the outgoing farm', // 请选择出库农场
  inboundFarm: '入库农场', // 入库农场
  building: '栋舍', // 栋舍
  pleaseSelectBuilding: '请选择栋舍', // 请选择栋舍
  feedingLot: '饲养批次', // 饲养批次
  pleaseEnterTheFeedingLot: '请输入饲养批次', // 请输入饲养批次
  pleaseSelectTheFeedingLot: '请选择饲养批次', // 请选择饲养批次
  typeOfDeparture: '出库类型', // 出库类型
  pleaseSelectTheTypeOfDeparture: '请选择出库类型', // 请选择出库类型
  dateOfRelease: '出库日期', // 出库日期
  pleaseSelectTheDateOfShipment: '请选择出库日期', // 请选择出库日期
  pleaseClickToSelectADepartment: '请点击选择部门', // 请点击选择部门
  storageType: '入库类型', // 入库类型
  pleaseSelectTheTypeOfStorage: '请选择入库类型', // 请选择入库类型
  dateOfStorage: '入库日期', // 入库日期
  pleaseSelectTheDateOfStorage: '请选择入库日期', // 请选择入库日期
  transferOutFarmServiceDepartment: '转出农场/服务部', // 转出农场/服务部
  pleaseSelectTransferringFarmService: '请选择转出农场/服务部', // 请选择转出农场/服务部
  transferToFarmService: '转入农场/服务部', // 转入农场/服务部
  pleaseSelectTheFarmServiceDepartmentToWhichYouAreTransferring: '请选择转入农场/服务部', // 请选择转入农场/服务部
  dateOfTransfer: '调拨日期', // 调拨日期
  pleaseSelectTheDateOfTransfer: '请选择调拨日期', // 请选择调拨日期
  breed: '品种', // 品种
  pleaseEnterTheBreed: '请输入品种', // 请输入品种
  pleaseSelectTheBreed: '请选择品种', // 请选择品种
  status: '状态', // 状态
  pleaseSelectStatus: '请选择状态', // 请选择状态
  batchNumber: '批号', // 批号
  pleaseEnterTheBatchNumber: '请输入批号', // 请输入批号
  productionBatchNumber: '生产批次编号', // 生产批次编号
  pleaseEnterTheProductionBatchNumber: '请输入生产批次编号', // 请输入生产批次编号
  theFirstAndLastBitOfTheBatchNumberIsNotAllowedToBeSpace: '批次编号首末位不允许为空格', // 批次编号首末位不允许为空格
  flockName: '批次名称', // 批次名称
  pleaseEnterTheFlockName: '请输入批次名称', // 请输入批次名称
  settlementBatchNumber: '结算批次编号', // 结算批次编号
  pleaseEnterTheSettlementBatchNumber: '请输入结算批次编号', // 请输入结算批次编号
  TheBatchNumberIsLimitedTo8Digits: '批次编号限制8位数字', // 批次编号限制8位
  placementAge: '入舍日龄', // 入舍日龄
  pleaseEnterTheStartingAge: '请输入起始日龄', // 请输入起始日龄
  category: '品类', // 品类
  pleaseSelectCategory: '请选择品类', // 请选择品类
  generation: '代次', // 代次
  pleaseSelectGeneration: '请选择代次', // 请选择代次
  breedingType: '养殖类型', // 养殖类型
  pleaseSelectBreedingType: '请选择养殖类型', // 请选择养殖类型
  startTimeOfVaccination: '防疫开始时间', // 防疫开始时间
  pleaseSelectTheStartTimeOfVaccination: '请选择防疫开始时间', // 请选择防疫开始时间
  plannedNumberOfHouses: '计划入舍数量', // 计划入舍数量
  pleaseEnterThePlannedNumberOfHouses: '请输入计划入舍数量', // 请输入计划入舍数量
  plannedDateOfArrival: '计划入舍日期', // 计划入舍日期
  pleaseSelectThePlannedArrivalDate: '请选择计划入舍日期', // 请选择计划入舍日期
  plannedTransferDate: '计划转场日期', // 计划转场日期
  pleaseSelectThePlanTransferDate: '请选择计划转场日期', // 请选择计划转场日期
  planPriceConfirmationDate: '计划身价确认日期', // 计划身价确认日期
  pleaseSelectThePlannedPriceConfirmationDate: '请选择计划身价确认（定栏）日期', // 请选择计划身价确认（定栏）日期
  plannedCullDate: '计划淘汰日期', // 计划淘汰日期
  pleaseSelectThePlannedEliminationDate: '请选择计划淘汰日期', // 请选择计划淘汰日期
  breedingMethod: '养殖方式', // 养殖方式
  pleaseSelectBreedingMethod: '请选择养殖方式', // 请选择养殖方式
  breeder: '饲养员', // 饲养员
  pleaseSelectBreeder: '请选择饲养员', // 请选择饲养员
  batchType: '批次类型', // 批次类型
  emptyDate: '空舍日期', // 空舍日期
  pleaseSelectTheDateOfEmptying: '请选择空舍日期', // 请选择空舍日期
  vaccinationStartDate: '防疫开始日期', // 防疫开始日期
  pleaseSelectTheStartDateOfVaccination: '请选择防疫开始时间', // 请选择防疫开始时间
  DaysOfAge127: '127日龄日期', // 127日龄日期
  currentAge: '当前日龄', // 当前日龄
  pleaseFillInTheCurrentAge: '请填写当前日龄', // 请填写当前日龄
  parentBatchNumber: '父级批次编号', // 父级批次编号
  pleaseFillInTheParentBatchNumber: '请填写父级批次编号', // 请填写父级批次编号
  preFeatheringAge: '换羽前日龄', // 换羽前日龄
  pleaseFillInTheAgeBeforeFledge: '请填写换羽前日龄', // 请填写换羽前日龄
  priceFixingDate: '身价确定日期', // 身价确定日期
  pleaseSelectTheDateOfPriceDetermination: '请选择身价确定日期', // 请选择身价确定日期
  priceDeterminationInventory: '身价确定存栏', // 身价确定存栏
  pleaseFillInThePriceDeterminationField: '请填写身价确定存栏', // 请填写身价确定存栏
  originalValue: '身价确定原值', // 身价确定原值
  pleaseFillInThePriceDeterminationOriginalValue: '请填写身价确定原值', // 请填写身价确定原值
  singleSalvageValue: '单只残值', // 单只残值
  pleaseFillInTheSingleSalvageValue: '请填写单只残值', // 请填写单只残值
  batchResidualValue: '批次残值', // 批次残值
  pleaseFillInTheLotResidualValue: '请填写批次残值', // 请填写批次残值
  batchNetValue: '批次净值', // 批次净值
  pleaseFillInTheBatchNetValue: '请填写批次净值', // 请填写批次净值
  assessedAmount: '已分摊金额', // 已分摊金额
  pleaseFillInTheApportionedAmount: '请填写已分摊金额', // 请填写已分摊金额
  deadTransferOut: '死淘转出', // 死淘转出
  pleaseFillInTheDeadAmalgamationTransferOut: '请填写死淘转出', // 请填写死淘转出
  totalMonthOfApportionment: '分摊总月份', // 分摊总月份
  pleaseFillInTheTotalMonthOfApportionment: '请填写分摊总月份', // 请填写分摊总月份
  apportionedMonth: '已分摊月份', // 已分摊月份
  pleaseFillInTheApportionedMonth: '请填写已分摊月份', // 请填写已分摊月份
  remainingMonths: '剩余分摊月份', // 剩余分摊月份
  pleaseFillInTheRemainingMonths: '请填写剩余分摊月份', // 请填写剩余分摊月份
  startPeriod: '开始分摊期间', // 开始分摊期间
  pleaseFillInTheStartPeriod: '请填写开始分摊期间', // 请填写开始分摊期间
  apportionedPeriod: '已分摊期间', // 已分摊期间
  pleaseFillInTheApportionedPeriod: '请填写已分摊期间', // 请填写已分摊期间
  nextApportionmentPeriod: '下次分摊期间', // 下次分摊期间
  pleaseFillInTheNextApportionmentPeriod: '请填写下次分摊期间', // 请填写下次分摊期间
  dateOfAcceptance: '验收日期', // 验收日期
  pleaseSelectTheDateOfAcceptance: '请选择验收日期', // 请选择验收日期
  receivingAndInspectionPersonnel: '验收人员', // 验收人员
  pleaseSelectTheAcceptancePersonnel: '请选择验收人员', // 请选择验收人员
  rejectedItem: '否决项', // 否决项
  pleaseEnterTheVetoItem: '请输入否决项', // 请输入否决项
  judgingCriteria: '评判标准', // 评判标准
  pleaseEnterTheJudgingCriteria: '请输入评判标准', // 请输入评判标准
  conclusion: '结论', // 结论
  pleaseSelectConclusion: '请选择结论', // 请选择结论
  synchronizationStatus: '同步状态', // 同步状态
  pleaseSelectTheSynchronizationStatus: '请选择同步状态', // 请选择同步状态
  dayAge: '日龄', // 日龄
  pleaseEnterTheAgeOfTheDay: '请输入日龄', // 请输入日龄
  weekAge: '周龄', // 周龄
  pleaseEnterTheAgeOfTheWeek: '请输入周龄', // 请输入周龄
  medicine: '药品', // 药品
  pleaseSelectMedicine: '请选择药品', // 请选择药品
  materialName: '物料名称', // 物料名称
  pleaseEnterTheNameOfTheMaterial: '请输入物料名称', // 请输入物料名称
  applicableScenario: '适用场景', // 适用场景
  pleaseSelectTheApplicableScenario: '请选择适用场景', // 请选择适用场景
  gender: '性别', // 性别
  pleaseSelectGender: '请选择性别', // 请选择性别
  documentInformation: '单据信息', // 单据信息
  pleaseSelectTheDocumentInformation: '请选择单据信息', // 请选择单据信息
  maximumIndoorTemperature: '最高室内温度(℃)', // 最高室内温度(℃)
  pleaseEnterTheHighestIndoorHumidity: '请输入最高室内湿度', // 请输入最高室内湿度
  lowestIndoorTemperature: '最低室内温度(℃)', // 最低室内温度(℃)
  pleaseEnterTheMinimumIndoorTemperature: '请输入最低室内温度', // 请输入最低室内温度
  maximumOutdoorTemperature: '最高室外温度(℃)', // 最高室外温度(℃)
  pleaseInputTheMaximumOutdoorTemperature: '请输入最高室外温度', // 请输入最高室外温度
  lowestOutdoorTemperature: '最低室外温度(℃)', // 最低室外温度(℃)
  pleaseInputTheLowestOutdoorTemperature: '请输入最低室外温度', // 请输入最低室外温度
  maximumBodyTemperature: '体感最高温度(℃)', // 体感最高温度(℃)
  pleaseInputTheMaximumBodyTemperature: '请输入体感最高温度', // 请输入体感最高温度
  minimumTemperature: '体感最低温度(℃)', // 体感最低温度(℃)
  pleaseInputTheLowestBodyTemperature: '请输入体感最低温度', // 请输入体感最低温度
  highestIndoorHumidity: '最高室内湿度(%)', // 最高室内湿度(%)
  lowestIndoorHumidity: '最低室内湿度(%)', // 最低室内湿度(%)
  pleaseEnterTheLowestIndoorHumidity: '请输入最低室内湿度', // 请输入最低室内湿度
  maximumOutdoorHumidity: '最高室外湿度(%)', // 最高室外湿度(%)
  pleaseEnterTheMaximumOutdoorHumidity: '请输入最高室外湿度', // 请输入最高室外湿度
  minimumOutdoorHumidity: '最低室外湿度(%)', // 最低室外湿度(%)
  pleaseEnterTheMinimumOutdoorHumidity: '请输入最低室外湿度', // 请输入最低室外湿度
  maximumLightIntensity: '最大光照强度(Lux)', // 最大光照强度(Lux)
  pleaseEnterTheMaximumLightIntensity: '请输入最大光照强度', // 请输入最大光照强度
  minimumLightIntensity: '最小光照强度(Lux)', // 最小光照强度(Lux)
  pleaseEnterTheMinimumLightIntensity: '请输入最小光照强度', // 请输入最小光照强度
  durationOfLight: '光照时长(h)', // 光照时长(h)
  pleaseEnterTheDurationOfLight: '请输入光照时长', // 请输入光照时长
  carbonDioxideConcentration: '二氧化碳浓度(%)', // 二氧化碳浓度(%)
  pleaseEnterTheCarbonDioxideConcentration: '请输入二氧化碳浓度', // 请输入二氧化碳浓度
  maxVentilationCoefficient: '最大通风系数', // 最大通风系数
  pleaseEnterTheMaximumVentilationFactor: '请输入最大通风系数', // 请输入最大通风系数
  minimumVentilationFactor: '最小通风系数', // 最小通风系数
  pleaseEnterTheMinimumVentilationFactor: '请输入最小通风系数', // 请输入最小通风系数
  waterConsumption: '耗水量(升)', // 耗水量(升)
  pleaseInputWaterConsumption: '请输入耗水量', // 请输入耗水量
  electricityConsumption: '耗电量', // 耗电量
  pleaseInputPowerConsumption: '请输入耗电量', // 请输入耗电量
  fuelType: '燃料类型', // 燃料类型
  fuelConsumption: '燃料消耗量', // 燃料消耗量
  pleaseInputFuelConsumption: '请输入燃料消耗量', // 请输入燃料消耗量
  cageUniformity: '笼位均匀度(%)', // 笼位均匀度(%)
  pleaseInputTheNumberOfCageUniformity: '请输入笼位均匀数', // 请输入笼位均匀数
  maximumIndoorTemperatureMustNotBeLessThanTheMinimumIndoorTemperature: '最高室内温度不能小于最低室内温度', // 最高室内温度不能小于最低室内温度
  maximumIndoorTemperatureMustBeLessThanTwoDecimalPlaces: '最高室内温度必须少于两位小数', // 最高室内温度必须少于两位小数
  minimumIndoorTemperatureCannotBeGreaterThanTheMaximumIndoorTemperature: '最低室内温度不能大于最高室内温度', // 最低室内温度不能大于最高室内温度
  minimumIndoorTemperatureMustBeLessThanTwoDecimalPlaces: '最低室内温度必须少于两位小数', // 最低室内温度必须少于两位小数
  theMaximumOutdoorTemperatureCannotBeLessThanTheMinimumOutdoorTemperature: '最高室外温度不能小于最低室外温度', // 最高室外温度不能小于最低室外温度
  theMaximumOutdoorTemperatureMustBeLessThanTwoDecimalPlaces: '最高室外温度必须少于两位小数', // 最高室外温度必须少于两位小数
  theMinimumOutdoorTemperatureCannotBeGreaterThanTheMaximumOutdoorTemperature: '最低室外温度不能大于最高室外温度', // 最低室外温度不能大于最高室外温度
  theMinimumOutdoorTemperatureMustBeLessThanTwoDecimalPlaces: '最低室外温度必须少于两位小数', // 最低室外温度必须少于两位小数
  theMaximumBodyTemperatureMustNotBeLessThanTheMinimumBodyTemperature: '最高体感温度不能小于最低体感温度', // 最高体感温度不能小于最低体感温度
  theMaximumBodyTemperatureMustBeLessThanTwoDecimalPlaces: '最高体感温度必须少于两位小数', // 最高体感温度必须少于两位小数
  theMinimumBodyTemperatureMustNotBeGreaterThanTheMaximumBodyTemperature: '最低体感温度不能大于最高体感温度', // 最低体感温度不能大于最高体感温度
  theMinimumBodyTemperatureMustBeLessThanTwoDecimalPlaces: '最低体感温度必须少于两位小数', // 最低体感温度必须少于两位小数
  theMaximumIndoorHumidityCannotBeLessThanTheMinimumIndoorHumidity: '最高室内湿度不能小于最低室内湿度', // 最高室内湿度不能小于最低室内湿度
  maximumIndoorHumidityMustBeLessThanTwoDecimalPlaces: '最高室内湿度必须少于两位小数', // 最高室内湿度必须少于两位小数
  theMinimumIndoorHumidityCannotBeGreaterThanTheMaximumIndoorHumidity: '最低室内湿度不能大于最高室内湿度', // 最低室内湿度不能大于最高室内湿度
  minimumIndoorHumidityMustBeLessThanTwoDecimalPlaces: '最低室内湿度必须少于两位小数', // 最低室内湿度必须少于两位小数
  theMaximumOutdoorHumidityMustNotBeLessThanTheMinimumOutdoorHumidity: '最高室外湿度不能小于最低室外湿度', // 最高室外湿度不能小于最低室外湿度
  maximumOutdoorHumidityMustBeLessThanTwoDecimalPlaces: '最高室外湿度必须少于两位小数', // 最高室外湿度必须少于两位小数
  theMinimumOutdoorHumidityCannotBeGreaterThanTheMaximumOutdoorHumidity: '最低室外湿度不能大于最高室外湿度', // 最低室外湿度不能大于最高室外湿度
  minimumOutdoorHumidityMustBeLessThanTwoDecimalPlaces: '最低室外湿度必须少于两位小数', // 最低室外湿度必须少于两位小数
  theMaximumVentilationCoefficientMustNotBeLessThanTheMinimumVentilationCoefficient: '最大通风系数不能小于最小通风系数', // 最大通风系数不能小于最小通风系数
  maximumVentilationCoefficientMustBeGreaterThanOrEqualTo: '最大通风系数必须大于等于0', // 最大通风系数必须大于等于0
  maximumVentilationCoefficientMustBeLessThanTwoDecimalPlaces: '最大通风系数必须少于两位小数', // 最大通风系数必须少于两位小数
  theMinimumVentilationCoefficientCannotBeGreaterThanTheMaximumVentilationCoefficient: '最小通风系数不能大于最大通风系数', // 最小通风系数不能大于最大通风系数
  minimumVentilationCoefficientMustBeGreaterThanOrEqualTo: '最小通风系数必须大于等于0', // 最小通风系数必须大于等于0
  minimumVentilationCoefficientMustBeLessThanTwoDecimalPlaces: '最小通风系数必须少于两位小数', // 最小通风系数必须少于两位小数
  waterConsumptionMustBeGreaterThanOrEqualTo: '耗水量必须大于等于0', // 耗水量必须大于等于0
  waterConsumptionMustBeLessThanTwoDecimalPlaces: '耗水量必须少于两位小数', // 耗水量必须少于两位小数
  powerConsumptionMustBeGreaterThanOrEqualTo: '耗电量必须大于等于0', // 耗电量必须大于等于0
  powerConsumptionMustBeLessThanTwoDecimalPlaces: '耗电量必须少于两位小数', // 耗电量必须少于两位小数
  theMaximumLightIntensityMustNotBeLessThanTheMinimumLightIntensity: '最大光照强度不能小于最小光照强度', // 最大光照强度不能小于最小光照强度
  maximumLightIntensityMustBeLessThanTwoDecimalPlaces: '最大光照强度必须少于两位小数', // 最大光照强度必须少于两位小数
  theMinimumLightIntensityMustNotBeGreaterThanTheMaximumLightIntensity: '最小光照强度不能大于最大光照强度', // 最小光照强度不能大于最大光照强度
  minimumLightIntensityMustBeLessThanTwoDecimalPlaces: '最小光照强度必须少于两位小数', // 最小光照强度必须少于两位小数
  theDurationOfLightMustBeGreaterThanOrEqualTo: '光照时长必须大于等于0', // 光照时长必须大于等于0
  theDurationOfLightMustBeLessThanTwoDecimalPlaces: '光照时长必须少于两位小数', // 光照时长必须少于两位小数
  carbonDioxideConcentrationMustBeGreaterThanOrEqualTo: '二氧化碳浓度必须大于等于0', // 二氧化碳浓度必须大于等于0
  carbonDioxideConcentrationMustBeLessThanTwoDecimalPlaces: '二氧化碳浓度必须少于两位小数', // 二氧化碳浓度必须少于两位小数
  fuelConsumptionMustBeGreaterThanOrEqualTo: '燃料消耗量必须大于等于0', // 燃料消耗量必须大于等于0
  fuelConsumptionMustBeLessThanTwoDecimalPlaces: '燃料消耗量必须少于两位小数', // 燃料消耗量必须少于两位小数
  cageUniformityMustBeGreaterThan: '笼位均匀数必须大于0', // 笼位均匀数必须大于0
  cageUniformityMustBeLessThanTwoDecimalPlaces: '笼位均匀数必须少于两位小数', // 笼位均匀数必须少于两位小数
  average: '平均值', // 平均值
  pleaseEnterTheAverageValue: '请输入平均值', // 请输入平均值
  pleaseAddDetails: '请添加明细', // 请添加明细
  upperLimit: '上限', // 上限
  lowerLimit: '下限', // 下限
  uniformity: '均匀度(%)', // 均匀度(%)
  submittedBy: '提报人', // 提报人
  pleaseSelectTheSubmitter: '请选择提报人', // 请选择提报人
  testingAge: '检测日龄', // 检测日龄
  pleaseInputTheTestingAge: '请输入检测日龄', // 请输入检测日龄
  sample: '样品', // 样品
  pleaseSelectSample: '请选择样品', // 请选择样品
  item: '项目', // 项目
  pleaseSelectTheItem: '请选择项目', // 请选择项目
  testPerson: '检测人员', // 检测人员
  pleaseSelectAcceptancePersonnel: '请选择检测人员', // 请选择检测人员
  testDate: '检测日期', // 检测日期
  pleaseSelectTheDateOfTesting: '请选择检测日期', // 请选择检测日期
  coefficientOfVariation: '变异系数', // 变异系数
  cullingLoss: '淘汰损失', // 淘汰损失
  totalNumberOfLivestock: '畜禽总数量', // 畜禽总数量
  numberOfSickHouses: '发病舍数量', // 发病舍数量
  deathLoss: '死亡损失', // 死亡损失
  ageAtDiseaseOnset: '发病日龄', // 发病日龄
  productionLoss: '生产损失', // 生产损失
  dateOfDiseaseOnset: '发病日期', // 发病日期
  pleaseSelectDateOfOnset: '请选择发病日期', // 请选择发病日期
  dateOfRecovery: '痊愈日期', // 痊愈日期
  pleaseSelectTheDateOfRecovery: '请选择痊愈日期', // 请选择痊愈日期
  testingCost: '检测费用', // 检测费用
  numberOfCases: '发病数', // 发病数
  incidenceRate: '发病率', // 发病率
  treatmentCost: '治疗费用', // 治疗费用
  numberOfCulling: '淘汰数', // 淘汰数
  cullingRate: '淘汰率', // 淘汰率
  preventionCosts: '预防费用', // 预防费用
  numberOfDeaths: '死亡数', // 死亡数
  mortalityRate: '死亡率', // 死亡率
  otherCosts: '其它费用', // 其它费用
  productionPerformance: '生产性能', // 生产性能
  diseaseCategory: '疾病类别', // 疾病类别
  totalLoss: '损失合计', // 损失合计
  prevalence: '流行情况', // 流行情况
  symptoms: '症状', // 症状
  dissectingLesions: '解刨病变', // 解刨病变
  detectionItemsAndResults: '检测项目及结果', // 检测项目及结果
  treatmentHistory: '处理经过', // 处理经过
  diagnosisResults: '诊断结果', // 诊断结果
  farmCode: '农场编码', // 农场编码
  month: '月份', // 月份
  pleaseSelectTheMonth: '请选择月份', // 请选择月份
  billMaker: '制单人', // 制单人
  pleaseSelectThePersonWhoInvitesOrderMaking: '请选择请制单人', // 请选择请制单人
  numberOfPeopleOnTheRegister: '在册人数', // 在册人数
  pleaseEnterTheNumberOfPeopleOnTheRegister: '请输入在册人数', // 请输入在册人数
  theNumberOfRegisteredPersonsMustBeAPositiveInteger: '在册人数必须为正整数', // 在册人数必须为正整数
  numberOfOutsideAssociates: '外协人数', // 外协人数
  pleaseEnterTheNumberOfOutsideAssociates: '请输入外协人数', // 请输入外协人数
  theNumberOfOutsourcedWorkersMustBeAPositiveInteger: '外协人数必须为正整数', // 外协人数必须为正整数
  farmerCode: '养户编码', // 养户编码
  pleaseEnterTheFarmerCode: '请输入养户编码', // 请输入养户编码
  farmerName: '养户名称', // 养户名称
  pleaseEnterTheFarmerName: '请输入养户名称', // 请输入养户名称
  farmerType: '养户类型', // 养户类型
  pleaseSelectTheTypeOfFarmer: '请选择养户类型', // 请选择养户类型
  code: '编码', // 编码
  pleaseEnterTheCode: '请输入编码', // 请输入编码
  name: '名称', // 名称
  pleaseEnterTheName: '请输入名称', // 请输入名称
  shortName: '简称', // 简称
  pleaseEnterTheShortName: '请输入简称', // 请输入简称
  fosterFamilyType: '养户类型', // 养户类型
  fosterName: '养户名称', // 养户名称
  pleaseEnterTheNameOfTheAdopter: '请输入养户名称', // 请输入养户名称
  taxpayerIdentificationNumber: '纳税人识别号', // 纳税人识别号
  pleaseEnterTheTaxpayerIdentificationNumber: '请输入纳税人识别', // 请输入纳税人识别
  idNumber: '身份证号', // 身份证号
  pleaseEnterTheIdCardNumber: '请输入身份证号', // 请输入身份证号
  substituteMaintenanceDepartment: '代养部', // 代养部
  serviceDepartment: '服务部', // 服务部
  pleaseSelectTheServiceDepartment: '请选择服务部', // 请选择服务部
  administrationArea: '行政管理片区', // 行政管理片区
  pleaseEnterTheAdministrativeArea: '请输入行政管理片区', // 请输入行政管理片区
  technician: '技术员', // 技术员
  pleaseEnterTechnician: '请输入技术员', // 请输入技术员
  supervisor: '分管领导', // 分管领导
  pleaseEnterTheSupervisor: '请输入分管领导', // 请输入分管领导
  isTheCompany: '是否公司', // 是否公司
  pleaseSelectWhetherItIsACompany: '请选择是否公司', // 请选择是否公司
  whetherSelfemployedOrNot: '是否个体户', // 是否个体户
  yes: '是', // 是
  no: '否', // 否
  pleaseEnterWhetherSelfemployedOrNot: '请输入是否个体户', // 请输入是否个体户
  longitude: '经度', // 经度
  pleaseEnterTheLongitude: '请输入经度', // 请输入经度
  latitude: '纬度',//纬度
  pleaseEnterLatitude: '请输入纬度', // 请输入纬度
  feedingArea: '喂养面积', // 喂养面积
  pleaseInputFeedingArea: '请输入喂养面积', // 请输入喂养面积
  breedingScale: '养殖规模(只）', // 养殖规模(只）
  pleaseEnterTheBreedingScale: '请输入养殖规模(只）', // 请输入养殖规模(只）
  timeZone: '时区', // 时区
  pleaseInputTimeZone: '请输入时区', // 请输入时区
  maximumRadius: '最大半径', // 最大半径
  pleaseEnterTheMaximumRadius: '请输入最大半径', // 请输入最大半径
  distanceToCompanyKm: '距离公司公里数', // 距离公司公里数
  pleaseEnterTheNumberOfKilometersFromTheCompany: '请输入距离公司公里数', // 请输入距离公司公里数
  breederStatus: '养户状态', // 养户状态
  pleaseSelectTheStatusOfTheBreeder: '请选择养户状态', // 请选择养户状态
  phoneNumber: '电话', // 电话
  pleaseEnterTelephone: '请输入电话', // 请输入电话
  cellPhone: '手机', // 手机
  pleaseEnterYourCellPhone: '请输入手机', // 请输入手机
  eMail: '邮箱', // 邮箱
  pleaseEnterYourEmailAddress: '请输入邮箱', // 请输入邮箱
  contactPerson: '联系人', // 联系人
  pleaseEnterYourContactPerson: '请输入联系人', // 请输入联系人
  weChat: '微信', // 微信
  pleaseInputWechat: '请输入微信', // 请输入微信
  QQ: 'QQ', // QQ
  pleaseEnterQQ: '请输入QQ', // 请输入QQ
  spouseName: '配偶姓名', // 配偶姓名
  pleaseEnterYourSpouseName: '请输入配偶姓名', // 请输入配偶姓名
  spouseCellPhone: '配偶手机', // 配偶手机
  pleaseEnterYourSpouseCellPhone: '请输入配偶手机', // 请输入配偶手机
  spouseIdNumber: '配偶身份证号', // 配偶身份证号
  pleaseEnterYourSpouseIdNumber: '请输入配偶身份证号', // 请输入配偶身份证号
  homeAddress: '家庭地址', // 家庭地址
  pleaseEnterYourHomeAddress: '请输入家庭地址', // 请输入家庭地址
  bankOfAccount: '开户银行', // 开户银行
  pleaseInputTheBankOfAccount: '请输入开户银行', // 请输入开户银行
  bankAddress: '开户行地址', // 开户行地址
  pleaseEnterTheAddressOfYourBank: '请输入开户行地址', // 请输入开户行地址
  accountNumber: '账号', // 账号
  pleaseEnterTheAccountNumber: '请输入账号', // 请输入账号
  accountName: '账户名（户主）', // 账户名（户主）
  pleaseEnterTheAccountName: '请输入账户名（户主）', // 请输入账户名（户主）
  accessDate: '准入日期', // 准入日期
  pleaseSelectTheAccessDate: '请选择准入日期', // 请选择准入日期
  expirationDate: '失效日期', // 失效日期
  pleaseSelectExpirationDate: '请选择失效日期', // 请选择失效日期
  affiliatedSupplier: '关联供应商', // 关联供应商
  affiliatedCustomer: '关联客户', // 关联客户
  country: '国家', // 国家
  pleaseSelectTheCountry: '请选择国家', // 请选择国家
  province: '省份', // 省份
  pleaseSelectTheProvince: '请选择省份', // 请选择省份
  cityPrefectureLevelCity: '市/地级市', // 市/地级市
  pleaseSelectTheCityPrefectureLevelCity: '请选择市/地级市', // 请选择市/地级市
  countyDistrict: '县/区', // 县/区
  pleaseSelectTheCountyDistrict: '请选择县/区', // 请选择县/区
  street: '乡镇/街道/社区', // 乡镇/街道/社区
  pleaseEnterStreet: '请输入乡镇/街道/社区', // 请输入乡镇/街道/社区
  address: '地址(街道门牌号)', // 地址(街道门牌号)
  pleaseEnterTheAddress: '请输入地址(街道门牌号)', // 请输入地址(街道门牌号)
  statusChangeTime: '状态改变时间', // 状态改变时间
  pleaseSelectTheTimeOfStatusChange: '请选择状态改变时间', // 请选择状态改变时间
  partnerType: '伙伴类型', // 伙伴类型
  pleaseSelectPartnerType: '请选择伙伴类型', // 请选择伙伴类型
  companyName: '公司名称', // 公司名称
  PleaseEnterTheCompanyName: '请输入公司名称', // 请输入公司名称
  partnerGrouping: '伙伴分组', // 伙伴分组
  PleaseEnterThePartnerGrouping: '请输入伙伴分组', // 请输入伙伴分组
  businessPartners: '业务伙伴', // 业务伙伴
  superiorPartnerCode: '上级合作商编码', // 上级合作商编码
  pleaseEnterTheSuperiorPartnerCode: '请输入上级合作商编码', // 请输入上级合作商编码
  enterpriseType: '企业类型', // 企业类型
  pleaseSelectTheTypeOfEnterprise: '请选择企业类型', // 请选择企业类型
  enterpriseTypeName: '企业类型名称', // 企业类型名称
  legalPerson: '法人', // 法人
  pleaseEnterTheLegalPerson: '请输入法人', // 请输入法人
  registeredAddress: '注册地址', // 注册地址
  pleaseEnterTheRegisteredAddress: '请输入注册地址', // 请输入注册地址
  registeredCapital: '注册资金(万元)', // 注册资金(万元)
  pleaseEnterTheRegisteredCapital: '请输入注册资金(万元)', // 请输入注册资金(万元)
  contactPhoneNumber: '联系电话', // 联系电话
  pleaseEnterYourContactNumber: '请输入联系电话', // 请输入联系电话
  email: '电子邮箱', // 电子邮箱
  pleaseEnterYourEmailAddress: '请输入电子邮箱', // 请输入电子邮箱
  taxpayerType: '纳税人类型', // 纳税人类型
  pleaseSelectTheTypeOfTaxpayer: '请选择纳税人类型', // 请选择纳税人类型
  taxpayerTypeDescription: '纳税人类型描述', // 纳税人类型描述
  taxpayerIdentificationNumberIDCcard: '纳税人识别号/身份证', // 纳税人识别号/身份证
  pleaseEnterTheTaxpayerIdentificationNumberIDCard: '请输入纳税人识别号/身份证', // 请输入纳税人识别号/身份证
  accountOpeningBank: '开户行', // 开户行
  pleaseInputTheAccountOpeningBank: '请输入开户行', // 请输入开户行
  accountOfTheBank: '开户行账户', // 开户行账户
  pleaseEnterTheAccountOfTheBank: '请输入开户行账户', // 请输入开户行账户
  validity: '有效性', // 有效性
  pleaseSelectWhetherItIsValidOrNot: '请选择是否有效', // 请选择是否有效
  materialCode: '物料编码', // 物料编码
  pleaseEnterTheMaterialCode: '请输入物料编码', // 请输入物料编码
  materialName: '物料名称', // 物料名称
  pleaseEnterTheMaterialName: '请输入物料名称', // 请输入物料名称
  materialGroup: '物料组', // 物料组
  pleaseSelectMaterialGroup: '请选择物料组', // 请选择物料组
  specification: '规格', // 规格
  pleaseEnterTheSpecification: '请输入规格型号', // 请输入规格型号
  manufacturer: '厂家', // 厂家
  pleaseEnterTheManufacturer: '请输入生产厂家', // 请输入生产厂家
  brand: '品牌', // 品牌
  pleaseInputTheBrand: '请输入品牌', // 请输入品牌
  level: '级别', // 级别
  pleaseSelectTheLevel: '请选择级别', // 请选择级别
  availableForSale: '可销售', // 可销售
  pleaseChooseWhetherYouCanSell: '请选择是否可销售', // 请选择是否可销售
  inventoryManagement: '库存管理', // 库存管理
  pleaseSelectWhetherInventoryManagement: '请选择是否库存管理', // 请选择是否库存管理
  inventoryUnit: '库存单位', // 库存单位
  pleaseSelectTheInventoryUnit: '请选择库存单位', // 请选择库存单位
  salesUnit: '销售单位', // 销售单位
  shelfLife: '保质期(天)', // 保质期(天)
  pleaseEnterTheShelfLife: '请输入保质期(天)', // 请输入保质期(天)
  description: '描述', // 描述
  pleaseEnterADescription: '请输入描述', // 请输入描述
  materialGroupClassification: '物料组分类', // 物料组分类
  pleaseSelectTheMaterialGroupClassification: '请选择物料组分类', // 请选择物料组分类
  warehouseCode: '仓库编码', // 仓库编码
  pleaseEnterTheWarehouseCode: '请输入仓库编码', // 请输入仓库编码
  warehouseName: '仓库名称', // 仓库名称
  pleaseEnterTheWarehouseName: '请输入仓库名称', // 请输入仓库名称
  ERPInventoryLocation: 'ERP库存地点', // ERP库存地点
  pleaseEnterTheERPInventoryLocation: '请输入ERP库存地点', // 请输入ERP库存地点
  warehouseType: '仓储类型', // 仓储类型
  pleaseSelectTheWarehouseType: '请选择仓储类型', // 请选择仓储类型
  warehouseIdentification: '仓库标识', // 仓库标识
  pleaseSelectTheWarehouseIdentification: '请选择仓库标识', // 请选择仓库标识
  affiliatedWarehouse: '所属仓库', // 所属仓库
  pleaseSelectTheAffiliatedWarehouse: '请选择所属仓库', // 请选择所属仓库
  maximumCapacity: '最大容量(kg)', // 最大容量(kg)
  pleaseEnterTheMaximumCapacity: '请输入最大容量(kg)', // 请输入最大容量(kg)
  organization: '所属机构', // 所属机构
  pleaseClickToSelectOrganization: '请点击选择所属机构', // 请点击选择所属机构
  storageManagement: '库位管理', // 库位管理
  defaultWarehouseLocation: '默认库位', // 默认库位
  purchaseUnit: '采购单位', // 采购单位
  pleaseSelectthePurchasingUnit: '请选择采购单位', // 请选择采购单位
  purchaseInventoryConversionRate: '采购-库存换算率', // 采购-库存换算率
  pleaseEnterTheConversionRate: '请输入换算率', // 请输入换算率
  whetherValid: '是否有效', // 是否有效
  factory: '工厂', // 工厂
  pleaseSelectFactory: '请选择工厂', // 请选择工厂
  factoryCode: '工厂编码', // 工厂编码
  pleaseSelectFactoryCode: '请选择工厂编码', // 请选择工厂编码
  batchManagement: '批次管理', // 批次管理
  convertibleMaterialName: '可转换物料名称', // 可转换物料名称
  pleaseEnterTheNameOfTheConvertibleMaterial: '请输入可转换物料名称', // 请输入可转换物料名称
  defaultVersion: '是否默认版本', // 是否默认版本
  standardType: '标准类型', // 标准类型
  whetherToDistinguishBetweenSexes: '是否区分性别', // 是否区分性别
  versionDescription: '版本描述', // 版本描述
  pleaseEnterTheVersionDescription: '请输入版本描述', // 请输入版本描述
  version: '版本', // 版本
  pleaseEnterTheVersion: '请输入版本', // 请输入版本
  type: '类型', // 类型
  eggFCRDuringLayingPeriod: '产蛋期料蛋比', // 产蛋期料蛋比\
  pleaseEnterTheEggFCRDuringTheEgglayingPeriod: '请输入产蛋期料蛋比', // 请输入产蛋期料蛋比
  totalUniformity: '全程均匀度', // 全程均匀度
  pleaseEnterTheTotalUniformity: '请输入全程均匀度', // 请输入全程均匀度
  breedingStrain: '品系', // 品系
  pleaseSelectBreed: '请选择品系', // 请选择品系
  effectiveDate: '生效日期', // 生效日期
  pleaseSelectEffectiveDate: '请选择生效日期', // 请选择生效日期
  grower: '养户', // 养户
  pleaseSelectGrower: '请选择养户', // 请选择养户
  menuType: '菜单类型', // 菜单类型
  firstLevelMenu: '一级菜单', // 一级菜单
  submenu: '子菜单', // 子菜单
  buttonsPermissions: '按钮/权限', // 按钮/权限
  pleaseEnterMenuName: '请输入菜单名称', // 请输入菜单名称
  parentMenu: '上级菜单', // 上级菜单
  pleaseSelectParentMenu: '请选择上级菜单', // 请选择上级菜单、请选择父级菜单
  menuPath: '菜单路径', // 菜单路径
  pleaseEnterTheMenuPath: '请输入菜单路径', // 请输入菜单路径
  frontComponents: '前端组件', // 前端组件
  pleaseEnterFrontComponents: '请输入前端组件', // 请输入前端组件
  defaultJumpAddress: '默认跳转地址', // 默认跳转地址
  pleaseEnterRouterRedirect: '请输入路由参数 redirect', // 请输入路由参数 redirect
  authorizationID: '授权标识', // 授权标识
  pleaseEnterAuthorization: '请输入授权标识, 如: user:list', // 请输入授权标识, 如: user:list
  authorizationPolicy: '授权策略', // 授权策略
  pleaseSelectAuthorizationPolicy: '请选择授权策略', // 请选择授权策略
  menuIcon: '菜单图标', // 菜单图标
  clickToSelectIcon: '点击选择图标', // 点击选择图标
  sort: '排序', // 排序
  pleaseEnterSort: '请输入序号', // 请输入序号
  pleaseEnterMenuSort: '请输入菜单排序', // 请输入菜单排序
  IfRouteMenu: '是否路由菜单', // 是否路由菜单
  hideRouting: '隐藏路由', // 隐藏路由
  ifCacheRoutes: '是否缓存路由', //是否缓存路由
  aggregateRouting: '聚合路由', // 聚合路由
  baseFlag: '可复制', // 可复制
  openMethod: '打开方式', // 打开方式
  external: '外部', // 外部
  internal: '内部', // 内部
  menuName: '菜单名称', // 菜单名称
  basicInformation: '基本信息', // 基本信息
  userInformation: '用户信息', // 用户信息
  departUser: '部门角色', // 部门角色
  organizationName: '机构名称', // 机构名称
  pleaseEnterOrganizationName: '请输入机构/部门名称', // 请输入机构/部门名称
  upperDivision: '上级部门', // 上级部门
  none: '无', // 无
  organizationCode: '机构编码', // 机构编码
  pleaseEnterTheOrganizationCode: '请输入机构编码', // 请输入机构编码
  orgShortCode: '机构简码', // 机构简码
  PleaseEnterShortCode: '请输入机构简码', // 请输入机构简码
  organizationID: '机构标识码', // 机构标识码
  pleaseEnterOrgID: '请输入机构标识码', // 请输入机构标识码
  personIncharge: '负责人', // 负责人
  pleaseSelectPersonIncharge: '请选择负责人', // 请选择负责人
  divisionHead: '分管领导', // 分管领导
  pleaseSelectDivisionHead: '请选择分管领导', // 请选择分管领导
  departAdmin: '部门管理员', // 部门管理员
  pleaseSelectDepartAdmin: '请选择部门管理员', // 请选择部门管理员
  orgType: '机构类型', // 机构类型
  companyType: '公司类型', // 公司类型
  pleaseSelectOrgType: '请选择机构类型', // 请选择机构类型
  serviceGroup: '服务组', // 服务组
  enabledOrNot: '是否启用', // 是否启用
  enable: '启用', // 启用
  disable: '禁用', // 禁用
  pleaseSelectAdopterCode: '请选择养户编码', // 请选择养户编码
  farms: '养殖场', // 养殖场
  cellPhoneNumber: '手机号', // 手机号
  pleaseInputCellPhoneNumber: '请输入手机号', // 请输入手机号
  factoryType: '工厂类型', // 工厂类型
  pleaseSelectFactoryType: '请选择工厂类型', // 请选择工厂类型
  uniformCreditCode: '统一信用代码', // 统一信用代码
  feedMillCode: '饲料厂编码', // 饲料厂编码
  pleaseEnterFeedMillCode: '请输入饲料厂编码', // 请输入饲料厂编码
  costCenter: '成本中心', // 成本中心
  pleaseEnterCostCenter: '请输入成本中心', // 请输入成本中心
  farmType: '农场类型', // 农场类型
  pleaseSelectFarmType: '请选择农场类型',// 请选择农场类型
  standardEmptyBarnPeriod: '标准空舍期',// 标准空舍期
  farmManager: '场长', // 场长
  pleaseEnterFarmManager: '请输入场长',// 请输入场长
  farmProperties: '农场属性', // 农场属性
  pleaseSelectFarmProperty: '请选择农场属性', // 请选择农场属性
  customer: '所属客户', // 所属客户
  pleaseEnterTheCustomerYouBelongTo: '请输入所属客户', // 请输入所属客户
  buildingStatus: '栋舍状态', // 栋舍状态
  pleaseSelectStatusOfBuilding: '请选择栋舍状态', // 请选择栋舍状态
  addressOnly: '地址', // 地址
  pleaseSelectAddress: '请选择地址', // 请选择地址
  capacity: '产能', // 产能
  startUpTime: '启用时间', // 启用时间
  pleaseSelectStartUpTime: '请选择启用时间', // 请选择启用时间
  deactivationTime: '停用时间', // 停用时间
  pleaseSelectDeactivationTime: '请选择停用时间', // 请选择停用时间
  buildingLength: '栋舍长度', // 栋舍长度
  buildingWidth: '栋舍宽度', // 栋舍宽度
  breedingArea: '养殖面积', // 养殖面积
  breedingMethod: '养殖方式', // 养殖方式
  pleaseSelectBreedingMethod: '请选择养殖方式', // 请选择养殖方式
  verticalFanPower: '竖向风机功率', // 竖向风机功率
  horizontalFanPower: '横向风机功率', // 横向风机功率
  detailedAddress: '详细地址', // 详细地址
  pleaseEnterDetailAddress: '请输入地址', // 请输入地址
  departmentPermissions: '部门权限', // 部门权限
  pleaseEnterDaysInStandardVacancyPeriod: '请输入标准空舍期天数', // 请输入标准空舍期天数
  oldPassword: '旧密码', // 旧密码
  pleaseEnterOldPassword: '请输入旧密码', // 请输入旧密码
  newPassword: '新密码', // 新密码
  pleaseEnterNewPassword: '请输入新密码', // 请输入新密码
  confirmNewPassword: '确认新密码', // 确认新密码
  pleaseConfirmNewPassword: '请输入新密码', // 请输入新密码
  hatchery: '孵化场', // 孵化场
  pleaseSelectHatchery: '请选择孵化场', // 请选择孵化场
  inspectedWarehouse: '待检仓库', // 待检仓库
  pleaseSelectInspectedWarehouse: '请选择待检仓库', // 请选择待检仓库
  seedEggBatchNumber: '种蛋批号', // 种蛋批号
  pleaseSelectSeedEggBatchNumber: '请选择种蛋批号', // 请选择种蛋批号
  byProductWarehouse: '副产品仓库', // 副产品仓库
  eggWarehouse: '种蛋仓库', // 种蛋仓库
  incubationFarm: '孵化农场', // 孵化农场
  pleaseSelectIncubationFarm: '请选择孵化农场', // 请选择孵化农场
  operationType: '操作类型', // 操作类型
  pleaseSelectOperationType: '请选择操作类型', // 请选择操作类型
  incubator: '孵化器', // 孵化器
  pleaseSelectIncubator: '请选择孵化器', // 请选择孵化器
  incubationBatchNumber: '孵化批号', // 孵化批号
  pleaseSelectIncubationBatchNumber: '请选择孵化批号', // 请选择孵化批号
  hatcher: '出雏器', // 出雏器
  pleaseSelectHatcher: '请选择出雏器', // 请选择出雏器
  immunizationDate: '免疫日期', // 免疫日期
  pleaseSelectImmunizationDate: '请选择免疫日期', // 请选择免疫日期
  roleName: '角色名称', // 角色名称
  pleaseEnterRoleName: '请输入角色名称', // 请输入角色名称
  languageName: '语言名称', // 语言名称
  languageCode: '语言编码', // 语言编码
  pleaseEnterlanguageName: '请输入语言名称', // 请输入语言名称
  pleaseEnterlanguageCode: '请输入语言编码', // 请输入语言编码
  languageDescription: '多语言描述', // 多语言描述
  pleaseEnterLanguageDescription: '请输入多语言描述', // 请输入多语言描述
  associatedDatabaseTable: '关联数据库表', // 关联数据库表
  pleaseEnterAssociatedDatabaseTable: '请输入关联数据库表', // 请输入关联数据库表
  associatedDataField: '关联数据字段', // 关联数据字段
  pleaseEnterAssociatedDataField: '请输入关联数据字段', // 请输入关联数据字段
  associatedBusinessType: '关联业务类型', // 关联业务类型
  associatedEntityField: '关联实体字段', // 关联实体字段
  roleCode: '角色编码', // 角色编码
  pleaseEnterRoleCode: '请输入角色编码', // 请输入角色编码
  twoToThirtyCharactersInLength: '长度在 2 到 30 个字符', // 长度在 2 到 30 个字符
  upToSixtyFourCharactersInLength: '长度不超过 64 个字符', // 长度不超过 64 个字符
  LessThanCharacters_126: '长度不超过 126 个字符', // 长度不超过 126 个字符
  noChineseCharactersAllowed: '角色编码不可输入汉字', // 角色编码不可输入汉字
  userAccount: '用户账号', // 用户账号
  departUserName: '部门角色名称', // 部门角色名称
  pleaseEnterDepartUserName: '请输入部门角色名称', // 请输入部门角色名称
  departUserCode: '部门角色编码', // 部门角色编码
  pleaseEnterDepartUserCode: '请输入部门角色编码', // 请输入部门角色编码
  pleaseEnterDepartUserName: '请输入部门角色', // 请输入部门角色
  pleaseEnterAccount: '请输入用户账号', // 请输入用户账号
  loginPassword: '登录密码', // 登录密码
  pleaseEnterLoginPassword: '请输入登录密码', // 请输入登录密码
  confirmPassword: '确认密码',// 确认密码
  pleaseConfirmLoginPassword: '请重新输入登录密码', // 请重新输入登录密码
  userName: '用户姓名', // 用户姓名
  pleaseEnterUsername: '请输入用户姓名',// 请输入用户姓名
  realName: '真实名字', // 真实名字
  pleaseEnterRealName: '请输入真实名字', // 真实名字
  pleaseEnterCellPhoneNumber: '请输入手机号',//请输入手机号
  userStatus: '用户状态', //用户状态
  employeeID: '工号', // 工号
  pleaseEnterWorkNumber: '请输入工号', // 请输入工号
  position: '职务', // 职务
  pleaseSelectJobTitle: '请选择职务',// 请选择职务
  roleAssignment: '角色分配', // 角色分配
  pleaseSelectUserRole: '请选择用户角色', // 请选择用户角色
  departmentAssignment: '部门分配', // 部门分配
  clickToSelectDepartment: '点击选择部门', // 点击选择部门
  tenantAssignment: '租户分配', // 租户分配
  selectTenantAssignment: '请选择租户分配', // 请选择租户分配
  identity: '身份', // 身份
  normalUser: '普通用户', // 普通用户
  supervisor: '上级', // 上级
  mainDepartment: '归属部门', // 归属部门
  pleaseSelectMainDepartment: '请选择归属部门', // 请选择归属部门
  responsibleDepartment: '负责部门', // 负责部门
  pleaseSelectDepartmentInCharge: '请选择负责部门', // 请选择负责部门
  image: '头像', //  头像
  upload: '上传', // 上传
  birthday: '生日', // 生日
  pleaseSelectYourBirthday: '请选择生日', // 请选择生日
  workflowEngine: '工作流引擎', // 工作流引擎
  pleaseSelectWhetherSynchronizeWorkflowEngine: '请选择是否同步工作流引擎', // 请选择是否同步工作流引擎
  male: '男', // 男
  female: '女', // 女
  pleaseEnterCorrectTelNumber: 'Please enter the correct landline number', // 请输入正确的座机号码
  deliveryOrderNo: '出雏单号', // 出雏单号
  pleaseSelectDeliveryOrderNo: '请选择出雏单号', // 请选择出雏单号
  hatchingDate: '出雏日期', // 出雏日期
  pleaseSelectHatchingDate: '请选择出雏日期', // 请选择出雏日期
  eggBatch: '种蛋批次', // 种蛋批次
  pleaseSelectEggBatch: '请选择种蛋批次', // 请选择种蛋批次
  numberOfEggKnocks: '敲蛋检查数', // 敲蛋检查数
  pleaseEnterTheNumberOfEggKnocks: '请输入敲蛋检查数', // 请输入敲蛋检查数
  resetPassword: '重新设定密码', // 重新设定密码
  thePasswordEnteredTwiceIsNotTheSame: '两次输入的密码不一样',//两次输入的密码不一样
  dictionaryName: '字典名称', // 字典名称
  pleaseEnterDictionaryName: '请输入字典名称', // 请输入字典名称
  dictionaryNumber: '字典编号', // 字典编号
  pleaseEnterDictionaryNum: '请输入字典编号', // 请输入字典编号
  dictionaryFetch: '字典取回', // 字典取回
  normal: '正常', // 正常
  pleaseEnterDataValue: '请输入数据值', // 请输入数据值
  dataValue: '数据值', // 数据值
  sortByVal: '排序值', // 排序值
  smallerFront: '值越小越靠前，支持小数', // 值越小越靠前，支持小数
  dataValuesCannotContainSpecialChar: '数据值不能包含特殊字符！', // 数据值不能包含特殊字符！
  dictionaryList: '字典列表', // 字典列表
  deleteDictionaryCompletely: '彻底删除字典', // 彻底删除字典
  areYouSureDeleteDictionaryCompletely: '您确定要彻底删除这个字典项吗?',// 您确定要彻底删除这个字典项吗
  notePleaseBeCarefulItCannotBeRecoveredAfterDeletion: '注意：彻底删除后将无法恢复，请谨慎操作！', // 注意：彻底删除后将无法恢复，请谨慎操作！
  categoryName: '分类名称', // 分类名称
  categoryCode: '分类编码',// 分类编码
  parentNode: '父级节点',// 父级节点
  pleaseSelectParentNode: '请选择父级节点', // 请选择父级节点
  pleaseInputCategoryName: '请输入分类名称', // 请输入分类名称
  user: '用户', // 用户
  permissionsHeld: '所拥有的权限', // 所拥有的权限
  pleaseSelectHigherDepartmentision: '请选择上级部门', // 请选择上级部门
  fax: '传真', // 传真
  pleaseEnterFax: '请输入传真', // 请输入传真
  menu: '菜单', // 菜单
  ruleName: '规则名称', // 规则名称
  pleaseEnterRuleName: '请输入规则名称', // 请输入规则名称
  ruleValue: '规则值',// 规则值
  pleaseEnterRuleVal: '请输入规则值', // 请输入规则值
  ruleField: '规则字段', // 规则字段
  pleaseEnterRuleField: '请输入规则字段', // 请输入规则字段
  conditionalRule: '条件规则', // 条件规则
  pleaseEnterConditionalRule: '请输入条件规则', // 请输入条件规则
  valid: '有效', // 有效
  invalid: '无效', // 无效
  pleaseEnterDepartmentName: '请输入部门名称', // 请输入部门名称
  department: '部门', // 部门
  pleaseSelectServiceDepartment: '请选择部门', // 请选择部门
  eRPSingleNumber: 'ERP单号',//ERP单号
  pleaseEnterERPSingleNumber: '请输入ERP单号', // 请输入ERP单号
  storehouseType: '仓库类型',//仓库类型
  pleaseSelectStorehouseType: '请选择仓库类型',//请选择仓库类型
  pleaseSelectFarms: '请选择养殖场', // 请选择养殖场
  farmingBatch: '养殖批次',
  pleaseEnterFarmingBatch: '请输入养殖批次', // 请输入养殖批次
  applicant: '申请人',//申请人
  pleaseSelectApplicant: '请选择申请人',//请选择申请人
  pleaseEnterTheDocumentNumber: '请输入单据编号',//请输入单据编号
  breedingCycle: '养殖周期',//养殖周期
  pleaseEnterTheBreedingPeriod: '请输入养殖周期',//请输入养殖周期
  plannedNumberOfSeedlings: '计划进苗数量',//计划进苗数量
  giftAmount: '赠与数量',//赠与数量
  pleaseEnterTheGiftAmount: '请输入赠与数量',//请输入赠与数量
  theNumberOfShipments: '发货数量',//发货数量
  pleaseEnterTheShippingQuantity: '请输入发货数量',//请输入发货数量
  plannedDateOfSeedling: '计划进苗日期',//计划进苗日期
  pleaseSelectThePlannedDateOfSeedling: '请选择计划进苗日期',//请选择计划进苗日期
  serviceCompany: '服务公司',//服务公司
  pleaseSelectAServiceCompany: '请选择服务公司',//请选择服务公司
  affiliatedCompany: '所属公司',//所属公司
  pleaseSelectaffiliatedCompany: '请选择所属公司',//请选择所属公司
  affiliatedTechnicalStaffNumber: '所属技术员工号',//所属技术员工号
  pleaseSelectaffiliatedTechnicalStaffNumber: '请选择所属技术员工号',//请选择所属技术员工号
  whetherSelfEmployed: '是否个体户',//是否个体户
  pleaseSelectWhetherSelfEmployed: '请选择是否个体户',//请选择是否个体户
  whetherEnterprise: '是否企业',//是否企业
  pleaseSelectWhetherEnterprise: '请选择是否企业',//是否企业
  growerStatus: '养户状态',//养户状态
  pleaseSelectGrowerStatus: '请选择养户状态',//请选择养户状态
  statusChangeTime: '状态改变时间',//状态改变时间
  pleaseSelectTheTimeOfStatusChange: '请选择状态改变时间',//请选择状态改变时间
  distanceToCompany: '距公司公里数',//距公司公里数
  pleaseEnterTheNumberOfKilometersFromTheCompany: '请输入距离公司公里数',//请输入距离公司公里数
  country: '国家',//国家
  province: '省份',//省份
  city: '市/地级市',//市/地级市
  county: '县/区',//县/区
  street: '乡镇/街道/社区',//乡镇/街道/社区
  pleaseEnterTheStreet: '请输入乡镇/街道/社区',//请输入乡镇/街道/社区
  address: '地址(街道门牌号)',//地址(街道门牌号)
  pleaseEnterTheAddress: '请输入地址(街道门牌号)',//请输入地址(街道门牌号)
  telephone: '电话',//电话
  pleaseEnterYourPhoneNumber: '请输入电话',//请输入电话
  spouseName: '配偶姓名',//配偶姓名
  pleaseEnterYourSpouseName: '请输入配偶姓名',//请输入配偶姓名
  spouseCellPhone: '配偶手机',//配偶手机
  pleaseEnterYourSpouseCellPhone: '请输入配偶手机',//请输入配偶手机
  spouseIDNumber: '配偶身份证号',//配偶身份证号
  pleaseEnterYourSpouseIDNumber: '请输入配偶身份证号',//请输入配偶身份证号
  homeAddress: '家庭地址',//家庭地址
  pleaseEnterYourHomeAddress: '请输入家庭地址',//请输入家庭地址
  bankAccount: '开户银行',//开户银行
  pleaseInputTheBankAccount: '请输入开户银行',//请输入开户银行
  bankAddress: '开户行地址',//开户行地址
  pleaseEnterTheBankAddress: '请输入开户行地址',//请输入开户行地址
  bankCardNumber: '银行卡号',//银行卡号
  pleaseInputTheBankCardNumber: '请输入银行卡号',//请输入银行卡号
  validOrNot: '是否有效',//是否有效
  pleaseChooseWhetherItIsValidOrNot: '请选择是否有效',//请选择是否有效
  remarks: '备注',//备注
  pleaseEnterANote: '请输入备注',//请输入备注
  pleaseEnterTheCorrectIDCardNumber: '请输入正确的身份证号',//请输入正确的身份证号
  pleaseEnterTheCorrectIDNumberOfYourSpouse: '请输入正确的配偶身份证号',//请输入正确的配偶身份证号
  pleaseEnterTheCorrectCellPhoneNumber: '请输入正确的手机号码',//请输入正确的手机号码
  sureToSubmit: '确定提交吗?',//确定提交吗
  oKToWriteOff: '确定冲销吗?',//确定冲销吗
  applicationOrderNo: '申请单号',//申请单号
  pleaseSelectTheApplicationNo: '请选择申请单号',//请选择申请单号
  shippingWarehouse: '发货仓库',//发货仓库
  contractID: '合同号',//合同号
  pleaseInputTheContractID: '请输入合同号',//请输入合同号
  detailPrimaryKey: '明细主键',//明细主键
  pleaseSelectLotNo: '请选择批号',//请选择批号
  mustBeOrPositiveInteger: '必须是或者正整数',//发货数量必须是或者正整数
  settlementAmount: '结算金额',//结算金额
  partyA: '甲方公司',//甲方公司
  pleaseSelectPartyA: '请选择甲方公司',//请选择甲方公司
  partyB: '乙方养户',//乙方养户
  pleaseSelectPartyB: '请选择乙方养户',//请选择乙方养户
  contracName: '合同名称',//合同名称
  pleaseEnterTheContractName: '请输入合同名称',//请输入合同名称
  cooperationMode: '合作模式',//合作模式
  pleaseSelectTheCooperationMode: '请选择合作模式',//请选择合作模式
  contractType: '合同类型',//合同类型
  pleaseSelectTheContractType: '请选择合同类型',//请选择合同类型
  dateOfSigning: '签订日期',//签订日期
  pleaseSelectTheDateOfSigning: '请选择签订日期',//请选择签订日期
  terminationDate: '终止日期',//终止日期
  pleaseSelectTheTerminationDate: '请选择合同终止日期',//请选择合同终止日期
  signingPlace: '签订地点',//签订地点
  pleaseEnterThePlaceOfSigning: '请输入签订地点',//请输入签订地点
  industry: '行业',//行业
  pleaseInputTheIndustry: '请输入行业',//请输入行业
  contractText: '合同文本',//合同文本
  pleaseEnterTheContractText: '请输入合同文本',//请输入合同文本
  whetherStandardText: '是否标准文本',//是否标准文本
  pleaseSelectWhetherTheStandardContractText: '请选择是否标准合同文本',//请选择是否标准合同文本
  currency: '币种',//币种
  pleaseEnterTheCurrency: '请输入币种',//请输入币种
  localCurrency: '本位币',//本位币
  pleaseEnterTheLocalCurrency: '请输入本位币',//请输入本位币
  conversionRate: '折本汇率',//折本汇率
  pleaseEnterTheConversionRate: '请输入折本汇率',//请输入折本汇率
  breedingCategory: '养殖品类',//养殖品类
  pleaseSelectSpecies: '请选择品类',//请选择品类
  breedingStrain: '养殖品系',//养殖品系
  pleaseSelectAStrain: '请选择品系',//请选择品系
  generation: '代次',//代次
  pleaseSelectSpecies: '请选择物种',//请选择物种
  breederAdministrator: '养户管理员',//养户管理员
  pleaseEnterTheBreederAdministrator: '请输入养户管理员',//请输入养户管理员
  serviceGroup: '服务组',//服务组
  pleaseSelectTheServiceGroup: '请选择服务组',//请选择服务组
  enteringPerson: '录入人',//录入人
  serviceTeamLeader: '服务组长',//服务组长
  pleaseEnterTheServiceGroupLeader: '请输入服务组长',//请输入服务组长
  marketingTeamLeader: '营销组长',//营销组长
  pleaseEnterTheMarketingTeamLeader: '请输入营销组长',//请输入营销组长
  salesperson: '营销员',//营销员
  pleaseEnterTheMarketingStaff: '请输入营销员',//请输入营销员
  changeOfContractCode: '变更合同编码',//变更合同编码
  pleaseEnterTheChangeContractCode: '请输入变更合同编码',//请输入变更合同编码
  changeTime: '变更时间',//变更时间
  pleaseSelectTheTimeOfChange: '请选择变更时间',//请选择变更时间
  reasonForChange: '变更原因',//变更原因
  pleaseEnterTheReasonForChange: '请输入变更原因',//请输入变更原因
  modifyTheContractText: '修改合同文本',//修改合同文本
  pleaseEnterTheTextOfTheModifiedContract: '请输入修改合同文本',//请输入修改合同文本
  breedingStandard: '养殖标准',//养殖标准
  pleaseEnteANumber: '请输入数字',//请输入数字
  age: '饲养天数',//饲养天数
  pleaseEnterAge: '请输入饲养天数',//请输入饲养天数
  numberOfContracts: '合同数量',//合同数量
  pleaseEnterTheNumberOfContracts: '请输入合同数量',//请输入合同数量
  day: '天',//天
  only: '只',//只
  maximumLivability: '成活率上限',//成活率上限
  pleaseEnterTheUpperLimitOfLivability: '请输入标准成活率上限',//请输入标准成活率上限
  minimumLivability: '成活率下限',//成活率下限
  pleaseEnteTheMinimumLivability: '请输入标准成活率下限',//请输入标准成活率下限
  wtandardLivability: '标准成活率',//标准成活率
  pleaseEnterTheStandardLivability: '请输入标准成活率',//请输入标准成活率
  weightLimit: '体重上限',//体重上限
  pleaseEnterTheUpperLimitOfStandardWeight: '请输入标准体重上限',//请输入标准体重上限
  lowerWeightLimit: '体重下限',//体重下限
  pleaseEnterTheLowerStandardWeightLimit: '请输入标准体重下限',//请输入标准体重下限
  standardWeight: '标准体重',//标准体重
  pleaseEnterStandardWeight: '请输入标准体重',//请输入标准体重
  uniformityUpperLimit: '均匀度上限',//均匀度上限
  pleaseEnterTheUpperLimitOfStandardEvenness: '请输入标准均匀度上限',//请输入标准均匀度上限
  lowerLimitOfUniformity: '均匀度下限',//均匀度下限
  pleaseEnterTheLowerLimitOfStandardUniformity: '请输入标准均匀度下限',//请输入标准均匀度下限
  standardUniformity: '标准均匀度',//标准均匀度
  pleaseEnterTheStandardUniformity: '请输入标准均匀度',//请输入标准均匀度
  upperLimitOfConsumption: '耗用量上限',//耗用量上限
  pleasEnterTheUpperLimitOfConsumptionPerUnit: '请输入单只耗用量上限',//请输入单只耗用量上限
  lowerLimitOfConsumption: '耗用量下限',//耗用量下限
  pleaseEnterTheLowerLimitOfConsumptionPerUnit: '请输入单只耗用量下限',//请输入单只耗用量下限
  standardConsumption: '标准耗用量',//标准耗用量
  pleaseEnterTheConsumptionAmountPerUnit: '请输入单只耗用量',//请输入单只耗用量
  upperLimitOfMeatRatio: '料肉比上限',//料肉比上限
  pleaseEnterTheUpperLimitOfStandardMeatRatio: '请输入标准料肉比上限',//请输入标准料肉比上限
  lowerLimitOfMeatRatio: '料肉比下限',//料肉比下限
  pleaseEnterTheLowerLimitOfStandardMeatRatio: '请输入标准料肉比下限',//请输入标准料肉比下限
  standardMeatRatio: '标准料肉比',//标准料肉比
  pleaseEnterTheStandardMeatRatio: '请输入标准料肉比',//请输入标准料肉比
  pleaseEnterAWholeNumber: '请输入整数',//请输入整数
  pleaseEnterANumber: '请输入数字',//请输入数字
  feather: '羽',//羽
  feedCost: '饲料成本',//饲料成本
  pleaseEnterTheFeedCostStandard: '请输入饲料成本标准',//请输入饲料成本标准
  rMBBird: '元/只',//元/只
  medicineCost: '药品成本',//药品成本
  pleaseInputTheCostStandardOfMedicine: '请输入药品成本标准',//请输入药品成本标准
  maleBirdAGrade: '公禽A级',//公禽A级
  pleaseEnterTheUnitPriceForTheRecoveryOfMaleBirdAGrade: '请输入公禽A级回收单价',//请输入公禽A级回收单价
  femaleAGrade: '母禽A级',//母禽A级
  pleaseEnterTheUnitPriceForTheRecoveryOfFemaleBirdAGrade: '请输入母禽A级回收单价',//请输入母禽A级回收单价
  maleB: '公禽B级',//公禽B级
  pleaseEnterTheUnitPriceOfMaleBirdBGrade: '请输入公禽B级回收单价',//请输入公禽B级回收单价
  femaleBirdBGrade: '母禽B级',//母禽B级
  pleaseEnterTheUnitPriceOfBGradeOfFemaleBirds: '请输入母禽B级回收单价',//请输入母禽B级回收单价
  maleBirdResidual: '公禽残次',//公禽残次
  pleaseEnterTheUnitPriceOfMaleBirdResidualRecovery: '请输入公禽残次回收单价',//请输入公禽残次回收单价
  femaleBirdResidual: '母禽残次',//母禽残次
  pleaseEnterTheUnitPriceOfFemalePoultryResidualRecovery: '请输入母禽残次回收单价',//请输入母禽残次回收单价
  yuanKg: '元/Kg',//元/Kg
  settlementBasis: '结算依据',//结算依据
  pleaseSelectTheBasisOfSettlement: '请选择结算依据',//请选择结算依据
  standardDailyFeePerAnimal: '每只每日标准代养费',//每只每日标准代养费
  pleaseEnterTheStandardDailyFeePerAnimal: '请输入每只每日标准代养费',//请输入每只每日标准代养费
  dividendPrice: '分红价格',//分红价格
  pleaseEnterTheDividendPrice: '请输入分红价格',//请输入分红价格
  companyCapitalPreservationPoint: '公司保本点',//公司保本点
  pleaseEnterTheCompanyCapitalPreservationPoint: '请输入公司保本点',//请输入公司保本点
  capitalPreservationPointForFarmers: '养户保本点',//养户保本点
  pleaseInputTheCapitalPreservationPointOfTheAdopter: '请输入养户保本点',//请输入养户保本点
  profitRatioOfPartyA: '甲方盈利比例',//甲方盈利比例
  pleaseEnterTheProfitRatioOfPartyA: '请输入盈利比例甲方',//请输入盈利比例甲方
  profitRatioOfPartyB: '乙方盈利比例',//乙方盈利比例
  pleaseInputTheProfitRatioOfPartyB: '请输入盈利比例乙方',//请输入盈利比例乙方
  LossRatioOfPartyA: '甲方亏损比例',//甲方亏损比例
  pleaseEnterThePercentageOfLossForPartyA: '请输入亏损比例甲方',//请输入亏损比例甲方
  partyBLossRatio: '乙方亏损比例',//乙方亏损比例
  pleaseInputLossRatioPartyB: '请输入亏损比例乙方',//请输入亏损比例乙方
  settlementAmountForPartyA: '甲方结算金额',//甲方结算金额
  settlementAmountOfPartyB: '乙方结算金额',//乙方结算金额
  yuan: '元',//元
  pleaseEnterTheCorrectAmount: '请输入正确的金额',//请输入正确的金额
  pleaseEnterTheUnitPrice: '请输入单价',//请输入单价
  balance: '余额',//余额
  pleaseEnterTheBalance: '请输入余额',//请输入余额
  amount: '金额',//金额
  pleaseEnterTheAmount: '请输入金额',//请输入金额
  unitPrice: '单价',//单价
  maximumLength6Bits: '最大长度6位',//最大长度6位
  planNo: '计划编号',//计划编号
  pleaseEnterPlanNo: '请输入计划编号',//请输入计划编号
  planDescription: '计划描述',// 计划描述
  pleaseEnterPlanDescription: '请输入计划描述',//请输入计划描述
  batchNo: '养殖批次',//养殖批次
  pleaseSelectBatchNo: '请选择养殖批次',//请选择养殖批次
  noPicture: '无图片',//无图片
  noFile: '无文件',//无文件
  download: '下载',//下载
  totalPlacement: '进苗总量',//进苗总量
  plannedPlacementDate: '计划进苗日期',//计划进苗日期
  confirmationTime: '确认时间',//确认时间
  reviewStatus: '审核状态',//审核状态
  maximumLength6Bits: '最大长度6位',//最大长度6位
  confirmSynchronization: '确定同步',//确定同步
  pleaseSelectAData: '请选择一条数据',//请选择一条数据
  thePlacementDateMustBeGreaterThanOrEqualToTheStartDate: '入舍日期必须大于等于批次空舍开始日期',//入舍日期必须大于等于批次空舍开始日期
  mustBeGreaterThanOrEqualTo0: '必须大于等于0',//必须大于等于0
  ifYouDoNotHaveAnAuditorYouCannotSubmit: '没有设置审核人员,不能提交',//没有设置审核人员,不能提交
  reviewer: '审核人',//审核人
  deliveryFarm: '交货农场',//交货农场
  sourceOrderType: '源单类型',//源单类型
  pleaseSelectTheSourceOrderType: '请选择源单类型',//请选择源单类型
  auxiliaryQuantity: '辅助数量',//辅助数量
  confirmCopy: '确定复制',//确定复制
  confrimToGenerateAStatement: '确定生成结算单',//确定生成结算单
  pleaseSelectTheBreedingStandard: '请选择养殖标准',//请选择养殖标准
  pleaseEnterTheDocumentNo: '请输入单据编号',//请输入单据编号
  pleaseSelectTheFarmNo: '请选择养殖场编号',//请选择养殖场编号
  pleaseSelectTheFarmerNo: '请选择养户编号',//请选择养户编号
  pleaseSelectTheStrain: '请选择品系',//请选择品系
  speciesClassification: '物种分类',//物种分类
  strain: '品系',//品系
  pleaseSelectSpecies: '请选择品类',//请选择品类
  pleaseInputTheBreedingCycle: '请输入养殖周期',//请输入养殖周期
  plannedNoOfPlacement: '计划进苗数量',//计划进苗数量
  pleaseInputThePlannedNoOfPlacement: '请输入计划进苗数量',//请输入计划进苗数量
  noOfGrants: '赠与数量',//赠与数量
  pleaseEnterTheNoOfGifts: '请输入赠与数量',//请输入赠与数量
  noOfShipments: '发货数量',//发货数量
  pleaseEnterTheNoOfShipments: '请输入发货数量',//请输入发货数量
  plannedDateOfPlacement: '计划进苗日期',//计划进苗日期
  pleaseSelectThePlannedDateOfPlacement: '请选择计划进苗日期',//请选择计划进苗日期
  pleaseInputTheApplicant: '请输入申请人',//请输入申请人
  productLine: '产品线',//产品线
  pleaseSelectTheProductLine: '请选择产品线',//请选择产品线
  auditStatus: '审核状态',//审核状态
  pleaseSelectTheAuditStatus: '请选择审核状态',//请选择审核状态
  validOrNot: '是否有效',//是否有效
  pleaseChooseWhetherItIsValidOrNot: '请选择是否有效',//请选择是否有效
  confirmedBy: '确认人',//确认人
  pleaseEnterThePersonWhoConfirmed: '请输入确认人',//请输入确认人
  pleaseEnterTheBatchNo: '请输入养殖批次编号',//请输入养殖批次编号
  pleaseEnterFarmNo: '请输入养殖场编号',//请输入养殖场编号
  pleaseEnterTheGrowerNo: '请输入养户编号',//请输入养户编号
  pleaseEnterTheContractId: '请输入合同编号',//请输入合同编号
  pleaseEnterTheNoOfGrants: '请输入赠送数量',//请输入赠送数量
  pleaseSelectTheCompanyCode: '请选择公司编码',//请选择公司编码
  pleaseSelectFarmCode: '请选择农场编码',//请选择农场编码
  pleaseSelectWarehouseCode: '请选择仓库编码',//请选择仓库编码
  applicationTime: '申请时间',//申请时间
  pleaseSelectTheApplicationTime: '请选择申请时间',//请选择申请时间
  pleaseEnterTheDocumentCategory: '请输入单据类别',//请输入单据类别
  billingPeriod: '单据账期',//单据账期
  pleaseSelectTheBillablePeriod: '请选择单据账期',//请选择单据账期
  demandTime: '需求时间',//需求时间
  pleaseSelectTheDemandTime: '请选择需求时间',//请选择需求时间
  requestedArrivalTime: '要求到货时间',//要求到货时间
  pleaseSelectTheRequiredArrivalTime: '请选择要求到货时间',//请选择要求到货时间
  qtyRequested: '申请数量',//申请数量
  pleaseEnterTheQtyRequested: '请输入申请数量',//请输入申请数量
  pleaseSelectTheQtyToBeShipped: '请选择发货数量',//请选择发货数量
  receivedQty: '收货数量',//收货数量
  pleaseEnterTheNoOfGoodsReceived: '请输入收货数量',//请输入收货数量
  pleaseEnterTheUnit: '请输入单位',//请输入单位
  unitNo: '单位编号',//单位编号
  pleaseEnterTheUnitNo: '请输入单位编号',//请输入单位编号
  costUnitPrice: '成本单价',//成本单价
  pleaseEnterTheCostUnitPrice: '请输入成本单价',//请输入成本单价
  pleaseEnterTheSettlementUnitPrice: '请输入结算单价',//请输入结算单价
  documentNo: '单据编号',//单据编号
  chickenApplicationForm: '鸡苗申请单',//鸡苗申请单
  pleaseSelectChickenApplicationForm: '请选择鸡苗申请单',//请选择鸡苗申请单
  species: '品种',//品种
  plannedDateOfPlacement: '进苗计划日期',//进苗计划日期
  pleaseEnterThePlannedDateOfPlacement: '请输入进苗计划日期',//请输入进苗计划日期
  shippingWarehouse: '发货仓库',//发货仓库
  pleaseSelectTheWarehouseForChickenDelivery: '请选择鸡发货仓库',//请选择鸡发货仓库
  pleaseEnterTheSettlementAmount: '请输入结算金额',//请输入结算金额
  pleaseEnterTheType: '请输入类型',//请输入类型
  documentDetails: '单据明细',//单据明细
  breedingLot: '养殖批次',//养殖批次
  entryType: '入库类型',//入库类型
  materialDetails: '物料明细',//物料明细
  death: '死亡数量',// 死亡数量
  pleaseEnterTheNoOfDeaths: '请输入死亡数量',//请输入死亡数量
  noOfCulling: '淘汰数量',//淘汰数量
  pleaseEnterTheNoOfCulling: '请输入淘汰数量',//请输入淘汰数量
  temperature: '温度',//温度
  pleaseEnterTheTemperature: '请输入温度',//请输入温度
  humidity: '湿度',//湿度
  pleaseInputHumidity: '请输入湿度',//请输入湿度
  batchNumber: '批次编号',//批次编号
  pleaseEnterTheBatchNumber: '请输入批次编号',//请输入批次编号
  batchName: '批次名称',//批次名称
  pleaseEnterTheBatchName: '请输入批次名称',//请输入批次名称
  pleaseSelectTheContractNumber: '请选择合同编号',//请选择合同编号
  feedingCycle: '饲养周期',//饲养周期
  pleaseEnterTheFeedingCycle: '请输入饲养周期',//请输入饲养周期
  species: '品类',//品类
  pleaseSelectStrain: '请选择品类',//请选择品类
  strain: '品系',//品系
  pleaseSelectAStrain: '请选择品系',//请选择品系
  generation: '代次',//代次
  initialAge: '初始日龄',//初始日龄
  pleaseEnterTheInitialAge: '请输入初始日龄',//请输入初始日龄
  plannedNumberOfChicks: '计划入雏数量',//计划入雏数量
  pleaseEnterThePlannedNumberOfChicks: '请输入计划入雏数量',//请输入计划入雏数量
  actualNumberOfChicks: '实际入雏数量',//实际入雏数量
  pleaseEnterTheActualNumberOfChicks: '请输入实际入雏数量',//请输入实际入雏数量
  remarks: '备注',//备注
  pleaseEnterAComment: '请输入备注',//请输入备注
  contractNo: '合同编号',//合同编号
  costItemClassificationCode: '费用项分类编码',//费用项分类编码
  pleaseEnterTheCostItemClassificationCode: '请输入费用项分类编码',//请输入费用项分类编码
  costItemClassification: '费用项分类',//费用项分类
  pleaseEnterTheCostItemClassification: '请输入费用项分类',//请输入费用项分类
  pleaseSelectAStatus: '请选择状态',//请选择状态
  pleaseEnterTheSupplierCode: '请输入供应商编码',//请输入供应商编码
  dateOfDemand: '需求日期',//需求日期
  materialNumber: '物料编号',//物料编号
  pleaseSelectTheMaterialNo: '请选择物料编号',//请选择物料编号
  pleaseEnterTheMaterialNo: '请输入物料编号',//请输入物料编号
  materialCommonName: '物料通用名',//物料通用名
  pleaseEnterTheCommonNameOfTheMaterial: '请输入物料通用名',//请输入物料通用名
  synchronousUpdate: '同步更新',//同步更新
  model: '型号',//型号
  unitOfMeasurement: '计量单位',//计量单位
  description: '说明描述',//说明描述
  materialCommonNameFileNo: '物料通用名档案编号',//物料通用名档案编号
  pleaseSelectTheMaterialCommonNameFileNo: '请选择物料通用名档案编号',//请选择物料通用名档案编号
  pleaseEnterTheMaterialCommonName: '请输入物料通用名',//请输入物料通用名
  contractCode: '合同编码',//合同编码
  pleaseSelectTheContractCode: '请选择合同编码',//请选择合同编码
  batchCode: '批次编码',//批次编码
  pleaseSelectBatchCode: '请选择批次编码',//请选择批次编码
  contracts: '合同',//合同
  batch: '批次',//批次
  pleaseSelectFarm: '请选择养殖场',//请选择养殖场
  receipt: '领用',//领用
  confirmApproval: '确定审核通过',//确定审核通过
  securityDepositOperation: '保证金操作',//保证金操作
  bookkeepingDate: '记账日期',//记账日期
  applicationInitiationTime: '申请发起时间',//申请发起时间
  lastApprover: '最后审批人',//最后审批人
  lastApprovalTime: '最后审批时间',//最后审批时间
  pleaseSelectContract: '请选择合同',//请选择合同
  pleaseSelectBatch: '请选择批次',//请选择批次
  batchSize: '批次规模',//批次规模
  businessDate: '业务日期',//业务日期
  businessType: '业务类型',//业务类型
  operationTime: '操作时间',//操作时间
  placementQty: '入雏数量',//入雏数量
  currentStock: '当前存栏数',//当前存栏数
  reasonForApplication: '申请原因',//申请原因
  auditStatus: '审核状态',//审核状态
  dateOfApplication: '申请日期',//申请日期
  finalApprover: '最后审批人',//最后审批人
  pleaseSelectContractNo: '请选择放养合同号',//请选择放养合同号
  applicationType: '申请类型',//申请类型
  totalAmount: '金额合计',//金额合计
  accountDate: '记账日期',//记账日期
  applicationInitiationDate: '申请发起日期',//申请发起日期
  cooperationModel: '合作模式',//合作模式
  partyBDividendRatio: '乙方分红比例',//乙方分红比例
  marketPrice: '市场价格',//市场价格
  exceedingPrice: '超出价格',//超出价格
  stocker: '放养员',//放养员
  stockerInCharge: '放养负责人',//放养负责人
  totalWeight: '出栏总重量',//出栏总重量
  dividendAmount: '分红金额',//分红金额
  okToUpdateTheStatement: '确定更新结算单',//确定更新结算单
  okToWithdraw: '确定撤回吗',//确定撤回吗
  withdraw: '撤回',//撤回
  partyA: '甲方公司',//甲方公司
  partyB: '乙方养户',//乙方养户
  contractName: '合同名称',//合同名称
  cooperationMode: '合作模式',//合作模式
  contractType: '合同类型',//合同类型
  dateOfContractSigning: '合同签订日期',//合同签订日期
  contractEffectiveDate: '合同生效日期',//合同生效日期
  contractTerminationDate: '合同终止日期',//合同终止日期
  placeOfSigning: '签订地点',//签订地点
  sector: '部门',//部门
  enteredBy: '录入人',//录入人
  conversionRate: '折本汇率',//折本汇率
  fosterCareAdministrator: '养户管理员',//养户管理员
  serviceGroup: '服务组',//服务组
  contractVersion: '合同版本',//合同版本
  batchNo: '批次编号',//批次编号
  pleaseEnterTheBatchNo: '请输入批次编号',//请输入批次编号
  batchOperation: '批量操作',//批量操作
  sureToWriteOff: '确定冲销吗',//确定冲销吗
  sureToDelete: '确定删除吗',//确定删除吗
  material: '物料',//物料
  pleaseSelectMaterial: '请选择物料',//请选择物料
  effectiveTime: '生效时间',//生效时间
  expirationTime: '失效时间',//失效时间
  isTheMaterialValid: '物料是否有效',//物料是否有效
  pleaseSelectACompany: '请选择公司',//请选择公司
  pleaseSelectAContract: '请选择合同',//请选择合同
  formula: '公式',//公式
  pleaseEnterAFormula: '请输入公式',//请输入公式
  substituteMaintenanceFeeCalculationFormula: '代养费计算公式',//代养费计算公式
  confirmDeletionOfThisItem: '确认删除此项',//确认删除此项
  verify: '验证',//验证
  variables: '变量',//变量
  operators: '运算符',//运算符
  pleaseEnterANo: '请输入数字',//请输入数字
  marketPriceRevenue: '市场价收入',//市场价收入
  contractPriceRevenue: '合同价收入',//合同价收入
  specificFeedCost: '特定饲料成本',//特定饲料成本
  chickCost: '鸡苗成本',//鸡苗成本
  feedCost: '饲料成本',//饲料成本
  drugCost: '药品成本',//药品成本
  vaccineCost: '疫苗成本',//疫苗成本
  totalCost: '总费用',//总费用
  totalReward: '总奖励',//总奖励
  totalPenalty: '总处罚',//总处罚
  catchQty: '出栏只数',//出栏只数
  catchWeight: '出栏重量',//出栏重量
  contractAverageWeight: '合同均重',//合同均重
  unitSurrogateBreedingFee: '单位代养费',//单位代养费
  unitManagementCost: '单位管理费用',//单位管理费用
  salesCostPerUnit: '单位销售费用',//单位销售费用
  enterANo: '输入数字',//输入数字
  pleaseEnterCompany: '请输入公司',//请输入公司
  chickenPrice: '成鸡价格',// 成鸡价格
  materialCategory: '物料类别',//物料类别
  mainUnitOfMeasurement: '主计量单位',//主计量单位
  pleaseEnterTheMainUnitOfMeasurement: '请输入主计量单位',//请输入主计量单位
  pleaseInputTheApplicationAmount: '请输入申请金额',//请输入申请金额
  pleaseSelectTheDateOfRecording: '请选择记账日期',//请选择记账日期
  pleaseSelectTheDateOfApplicationInitiation: '请选择申请发起日期',//请选择申请发起日期
  dividendRatio: '分红比例',//分红比例
  pleaseEnterThePercentageOfDividends: '请输入分红比例',//请输入分红比例
  pleaseEnterTheDividendPrice: '请输入分红价格',//请输入分红价格
  pleaseEnterTheMarketPrice: '请输入市场价格',//请输入市场价格
  pleaseEnterTheExcessPrice: '请输入超出价格',//请输入超出价格
  pleaseSelectAStocker: '请选择放养员',//请选择放养员
  pleaseSelectThePersonInChargeOfStocking: '请选择放放养负责人',//请选择放放养负责人
  pleaseEnterTheTotalCatchWeight: '请输入出栏总重量',//请输入出栏总重量
  pleaseEnterTheAmountOfDividends: '请输入分红金额',//请输入分红金额
  fileCode: '档案编码',//档案编码
  pleaseEnterTheFileCode: '请输入档案编码',//请输入档案编码
  fileDescription: '档案描述',//档案描述
  pleaseEnterTheFileDescription: '请输入档案描述',//请输入档案描述
  affiliateCategory: '关联类别',//关联类别
  costItems: '成本项目',//成本项目
  diseaseFileCode: '疾病档案编码',//疾病档案编码
  pleaseEnterTheDiseaseFileCode: '请输入疾病档案编码',//请输入疾病档案编码
  diseaseCategory: '疾病类别',//疾病类别
  pleaseSelectADiseaseCategory: '请选择疾病类别',//请选择疾病类别
  diseaseFileDescription: '疾病档案描述',//疾病档案描述
  associatedDiseaseCategories: '关联疾病类别',//关联疾病类别
  diseaseDescription: '疾病说明',//疾病说明
  symptomProfileCodes: '症状档案编码',//症状档案编码
  pleaseEnterTheSymptomProfileCode: '请输入症状档案编码',//请输入症状档案编码
  symptomProfileName: '症状档案名称',//症状档案名称
  pleaseEnterTheNameOfTheSymptomProfile: '请输入症状档案名称',//请输入症状档案名称
  fileType: '档案类型',//档案类型
  symptomFileDescription: '症状档案描述',//症状档案描述
  treatmentPlanName: '治疗方案名称',//治疗方案名称
  pleaseEnterTheNameOfTheTreatmentPlan: '请输入治疗方案名称',//请输入治疗方案名称
  treatmentPlanDescription: '治疗方案描述',//治疗方案描述
  organsAnatomyFileCode: '脏器解剖档案编码',//脏器解剖档案编码
  pleaseEnterTheAnatomyFileCode: '请输入脏器解剖档案编码',//请输入脏器解剖档案编码
  anatomyFileName: '脏器解剖档案名称',//脏器解剖档案名称
  pleaseEnterTheNameOfTheOrganAutopsyFile: '请输入脏器解剖档案名称',//请输入脏器解剖档案名称
  pleaseSelectValidOrNot: '请选择是否有效',//请选择是否有效
  visceralAnatomyFileType: '脏器解剖档案类型',//脏器解剖档案类型
  organDissectionClassification: '脏器解剖分类',//脏器解剖分类
  descriptionOfTheOrganDissectionFile: '脏器解剖档案描述',//脏器解剖档案描述
  inspectionSubcategoryCode: '巡检小类编码',//巡检小类编码
  pleaseEnterTheInspectionSubcategoryCode: '请输入巡检小类编码',//请输入巡检小类编码
  descriptionOfInspectionSubcategory: '巡检小类描述',//巡检小类描述
  pleaseEnterTheInspectionSubcategoryDescription: '请输入巡检小类描述',//请输入巡检小类描述
  inspectionCategory: '巡检大类',//巡检大类
  pleaseSelectTheInspectionCategory: '请选择巡检大类',//请选择巡检大类
  inspectionSubCategoryNumber: '巡检小类编号',//巡检小类编号
  nameOfInspectionCategory: '巡检小类名称',//巡检小类名称
  recurringIndicatorFileNumber: '循环指标档案编号',//循环指标档案编号
  pleaseEnterTheCycleIndexFileNumber: '请输入循环指标档案编号',//请输入循环指标档案编号
  circularIndicatorFileName: '循环指标档案名称',//循环指标档案名称
  pleaseEnterTheNameOfTheCircularIndicatorFile: '请输入循环指标档案名称',//请输入循环指标档案名称
  breedingCategory: '饲养品类',//饲养品类
  feedingStage: '饲养阶段',//饲养阶段
  survivalRate: '成活率',//成活率
  averageWeightOfAdultChickens: '成禽均重',//成鸡均重
  feedingAmount: '喂料量',//喂料量
  realMeatRatio: '真实料肉比',//真实料肉比
  regularRatio: '常规料肉比',//常规料肉比
  serviceCompanyGuaranteePoint: '服务公司保本点',//服务公司保本点
  seedlingPriceToMeatRatio: '种苗价肉比',//种苗价肉比
  feedToMeatRatio: '饲料价肉比',//饲料价肉比
  vaccinePriceToMeatRatio: '疫苗价肉比',//疫苗价肉比
  healthCareMedicinePriceToMeatRatio: '保健药价肉比',//保健药价肉比
  treatmentMedicinePriceToMeatRatio: '治疗药价肉比',//治疗药价肉比
  priceToMeatRatioForPayingFarmers: '支付养户成本价肉比',//支付养户成本价肉比
  fileName: '档案名称',//档案名称
  pleaseEnterTheNameOfTheFile: '请输入档案名称',//请输入档案名称
  standardCycleIndicatorNumber: '标准循环指标编号',//标准循环指标编号
  standardCycleIndicatorName: '标准循环指标名称',//标准循环指标名称
  pleaseEnterTheFileName: '请输入档案名称',//请输入档案名称
  chickenInspectionCode: '鸡苗检查编码',//鸡苗检查编码
  descriptionOfChickenInspection: '鸡苗检查描述',//鸡苗检查描述
  pleaseSelectTheCategoryOfAssociation: '请选择关联类别',//请选择关联类别
  pleaseSelectTheTypeOfFile: '请选择档案类型',//请选择档案类型
  symptomCategory: '症状类别',//症状类别
  pleaseSelectAnExpenseItemCategory: '请选择费用项类别',//请选择费用项类别
  pleaseEnterADiseaseFileDescription: '请输入疾病档案描述',//请输入疾病档案描述
  associatedDiseaseDescription: '关联疾病说明',//关联疾病说明
  pleaseEnterADiseaseDescription: '请输入疾病说明或描述',//请输入疾病说明\描述
  symptomProfile: '症状档案',//症状档案
  symptomName: '症状名称',//症状名称
  symptomDescription: '症状说明',//症状说明
  visceralAnatomyProfile: '脏器解剖档案',//脏器解剖档案
  organAnatomyName: '脏器解剖名称',//脏器解剖名称
  organAnatomyDescription: '脏器解剖说明',//脏器解剖说明
  treatmentPlanFile: '治疗方案档案',//治疗方案档案
  treatmentProtocolName: '治疗方案名称',//治疗方案名称
  treatmentProtocolDescription: '治疗方案说明',//治疗方案说明
  symptomCategory: '症状类别',//症状类别
  pleaseEnterTheSymptomFileCode: '请输入症状档案编码',//请输入症状档案编码
  pleaseEnterTheNameOfTheSymptomProfile: '请输入症状档案名称',//请输入症状档案名称
  symptomProfileDescription: '症状档案描述',//症状档案描述
  pleaseEnterTheSymptomProfileDescription: '请输入症状档案描述',//请输入症状档案描述
  treatmentPlanCode: '治疗方案编码',//治疗方案编码
  pleaseEnterTheTreatmentPlanCode: '请输入治疗方案编码',//请输入治疗方案编码
  treatmentPlanDescription: '治疗方案描述',//治疗方案描述
  pleaseEnterTheTreatmentProtocolDescription: '请输入治疗方案描述',//请输入治疗方案描述
  organsAnatomyCategory: '脏器解剖类别',//脏器解剖类别
  pleaseSelectAnatomyCategory: '请选择脏器解剖类别',//请选择脏器解剖类别
  descriptionOfTheOrganAutopsyFile: '脏器解剖档案描述',//脏器解剖档案描述
  pleaseEnterTheOrganAutopsyFileDescription: '请输入脏器解剖档案描述',//请输入脏器解剖档案描述
  pleaseEnterTheInspectionItemDescription: '请输入巡检项描述',//请输入巡检项描述
  pleaseSelectTheBreedingCategory: '请选择饲养品类',//请选择饲养品类
  pleaseEnterTheFeedingStage: '请输入饲养阶段',//请输入饲养阶段
  pleaseSelectRearingPeriod: '请选择饲养周期',//请选择饲养周期
  pleaseInputTheSurvivalRate: '请输入成活率',//请输入成活率
  pleaseEnterTheAverageWeightOfAdultChickens: '请输入成禽均重',//请输入成鸡均重
  pleaseEnterTheFeedingRate: '请输入喂料量',//请输入喂料量
  pleaseEnterTheRealMeatRatio: '请输入真实料肉比',//请输入真实料肉比
  pleaseEnterTheRegularMeatRatio: '请输入常规料肉比',//请输入常规料肉比
  pleaseEnterTheServiceCompanyGuaranteePoint: '请输入服务公司保本点',//请输入服务公司保本点
  pleaseEnterTheSeedlingPriceToMeatRatio: '请输入种苗价肉比',//请输入种苗价肉比
  pleaseEnterFeedPriceToMeatRatio: '请输入饲料价肉比',//请输入饲料价肉比
  pleaseEnterVaccinePriceToMeatRatio: '请输入疫苗价肉比',//请输入疫苗价肉比
  pleaseEnterHealthDrugPriceToMeatRatio: '请输入保健药价肉比',//请输入保健药价肉比
  pleaseEnterThePriceOfTherapeuticDrugs: '请输入治疗药价肉比',//请输入治疗药价肉比
  pleaseEnterTheMeatRatioOfTheCostOfPayingFarmers: '请输入支付养户成本价肉比',//请输入支付养户成本价肉比
  pleaseSelectMenuType: '请选择菜单类型', // 请选择菜单类型
  whetherInventoryManagement: '是否库存管理',//是否库存管理
  deliveryDate: '交货日期',//交货日期
  pleaseSelectDeliveryDate: '请选择交货日期', // 请选择交货日期
  batchSource: '批次来源',//批次来源
  pleaseSelectBatchSource: '请选择批次来源',//请选择批次来源
  pleaseSelectEffectiveTime: '请选择生效时间',//请选择生效时间
  pleaseSelectContractID: '请选择合同号',//请选择合同号
  settlementUnitPrice: '结算单价',//结算单价
  pleaseSelectTheBreedingStandard: '请选择养殖标准',//请选择养殖标准
  docCost: '禽苗成本',//禽苗成本
  pleaseEnterTheDocCost: '请输入禽苗成本标准',//请输入禽苗成本标准
  unitPriceType: '单价类型',//单价类型
  marginRecord: '保证金记录',//保证金记录
  businessItem: '业务项目',//业务项目
  placementDate: '进鸡日期',//进鸡日期
  changeType: '变更类型',//变更类型
  pleaseSelectChangeType: '请选择变更类型',//请选择变更类型
  method: '方式',//方式
  pleaseSelectMethod: '请选择方式',//请选择方式
  drawDownContractPriceList: '提取合同价格清单',//提取合同价格清单
  docApplicationForm: '禽苗申请单',//禽苗申请单
  pleaseSelectTheDocRequestForm: '请选择禽苗申请单',//请选择禽苗申请单
  pleaseSelectThePoultryDeliveryWarehouse: '请选择禽发货仓库',//请选择禽发货仓库
  pleaseEnter0OrPositiveInteger: '请输入0或正整数',//请输入0或正整数
  pleaseSelectBusinessType: '请选择业务类型',//请选择业务类型
  paymentMethod: '付款方式',//付款方式
  theCodeMustStartWithALetterAndCanContainNumbersUnderscoresHorizontalBars: '编码必须以字母开头，可包含数字、下划线、横杠',//编码必须以字母开头，可包含数字、下划线、横杠'
  extractTheListOfContractPrices: '提取合同价格清单',//提取合同价格清单
  pleaseSelectThePaymentMethod: '请选择付款方式',//请选择付款方式
  pleaseSelectTheApplicationInitiationTime: '请选择申请发起时间',//请选择申请发起时间
  mustBe0OrAPositiveInteger: '必须为0或正整数',//必须为0或正整数
  minimumPrice: '最低价',//最低价
  lowestPriceCannotBeGreaterThanTheHighestPrice: '最低价不能大于最高价',//最低价不能大于最高价
  highestPrice: '最高价',//最高价
  theHighestPriceCannotBeLessThanTheLowestPrice: '最高价不能小于最低价',//最高价不能小于最低价
  eggStorage: '蛋品入库(换羽)',//蛋品入库(换羽)
  detailImport: '明细导入',//明细导入
  materialConversionDetails: '物料转换明细',//物料转换明细
  newFarm: '新增养殖场',//新增养殖场
  kiloBird: '斤/羽',//斤/羽
  rmbKilo: '元/斤',//元/斤
  changeRange: '变更范围',//变更范围
  settlementDate: '结算日期',//结算日期
  breedingContract: '养殖合同',//养殖合同
  pleaseEnterTheBreedingContract: '请输入养殖合同',//请输入养殖合同
  pleaseSelectTheSettlementDate: '请选择结算日期',//请选择结算日期
  numberOfSlaughter: '出栏数量',//出栏数量
  bird: '羽',//羽
  deductedWeight: '扣减重量',//扣减重量
  deductionAmount: '扣减金额',//扣减金额
  pleaseEnterTheAmountToBeDeducted: '请输入扣减金额',//请输入扣减金额
  increaseInWeight: '增加重量',//增加重量
  pleaseEnterTheIncreaseWeight: '请输入增加重量',//请输入增加重量
  increaseAmount: '增加金额',//增加金额
  pleaseEnterTheIncreaseAmount: '请输入增加金额',//请输入增加金额
  averageUnitPrice: '平均单价',//平均单价
  pleaseEnterTheAverageUnitPrice: '请输入平均单价',//请输入平均单价
  pleaseEnterTheNumberOfSlaughters: '请输入出栏数量',//请输入出栏数量
  theNumberOfSlaughterMustBeGreaterThan0: '出栏数量必须大于0',//出栏数量必须大于0
  pleaseEnterTheContractQuantity: '请输入合同数量',//请输入合同数量
  contractQuantityMustBeGreaterThan0: '合同数量必须大于0',//合同数量必须大于0
  pleaseEnterTheSlaughterWeight: '请输入出栏重量',//请输入出栏重量
  slaughterWeightMustBeGreaterThan0: '出栏重量必须大于0',//出栏重量必须大于0
  pleaseEnterTheDeductionWeight: '请输入扣减重量',//请输入扣减重量
  deductedWeightMustBeGreaterThanOrEqualTo0: '扣减重量必须大于等于0',//扣减重量必须大于等于0
  pleaseEnterTheIncreaseWeight: '请输入增加重量',//请输入增加重量
  increaseWeightMustBeGreaterThanOrEqualTo0: '增加重量必须大于等于0',//增加重量必须大于等于0
  unitPriceMustBeGreaterThanOrEqualTo0: '单价必须大于等于0',//单价必须大于等于0
  amountMustBeGreaterThanOrEqualTo0: '金额必须大于等于0',//金额必须大于等于0
  pleaseEnterTheAmountToBeDeducted: '请输入扣减金额',//请输入扣减金额
  deductionAmountMustBeGreaterThanOrEqualTo0: '扣减金额必须大于等于0',//扣减金额必须大于等于0
  pleaseEnterTheIncreaseAmount: '请输入增加金额',//请输入增加金额
  theIncreaseAmountMustBeGreaterThanOrEqualTo0: '增加金额必须大于等于0',//增加金额必须大于等于0
  numberOfSlaughtered: '出栏羽数',//出栏羽数
  weightOfSlaughter: '出栏重量(kg)',//出栏重量(kg)
  averagePigeonWeight: '平均羽重(kg/羽)',//平均羽重(kg/羽)
  amountOfRecovery: '回收金额',//回收金额
  numberOfDoc: '禽苗数',//禽苗数
  pleaseEnterTheNumberOfDoc: '请输入禽苗数',//请输入禽苗数
  mortality: '死淘数',//死淘数
  pleaseEnterTheMortaility: '请输入死淘数',//请输入死淘数
  numberOfGifts: '赠送数',//赠送数
  pleaseEnterTheNumberOfGifts: '请输入赠送数',//请输入赠送数
  amountOfDoc: '禽苗金额',//禽苗金额
  pleaseEnterTheAmountOfDoc: '请输入禽苗金额',//请输入禽苗金额
  feedConsumption: '饲料耗用量',//饲料耗用量
  pleaseEnterTheAmountOfFeedConsumed: '请输入饲料耗用量',//请输入饲料耗用量
  amountOfFeed: '饲料金额',//饲料金额
  pleaseEnterTheAmountOfFeed: '请输入饲料金额',//请输入饲料金额
  amountOfMedicineConsumption: '药品耗用金额',//药品耗用金额
  pleaseEnterTheAmountOfMedicineConsumption: '请输入药品耗用金额',//请输入药品耗用金额
  amountOfVaccineConsumption: '疫苗耗用金额',//疫苗耗用金额
  pleaseEnterTheAmountOfVaccineConsumption: '请输入疫苗耗用金额',//请输入疫苗耗用金额
  totalAmount: '合计金额',//合计金额
  pleaseEnterTheTotalAmount: '请输入合计金额',//请输入合计金额
  pleaseEnterTheMortality: '请输入死淘数',//请输入死淘数
  amountRecovered: '回收金额',//回收金额
  pleaseEnterTheAmountRecovered: '请输入回收金额',//请输入回收金额
  costAmount: '成本金额',//成本金额
  pleaseEnterTheCostAmount: '请输入成本金额',//请输入成本金额
  subsidyAmount: '补贴金额',//补贴金额
  pleaseEnterTheAmountOfSubsidy: '请输入补贴金额',//请输入补贴金额
  otherSubsidies: '其他补贴',//其他补贴
  pleaseEnterOtherSubsidies: '请输入其他补贴',//请输入其他补贴
  costAmount: '费用金额',//费用金额
  pleaseEnterTheAmountOfExpenses: '请输入费用金额',//请输入费用金额
  penaltyAmount: '惩罚金额',//惩罚金额
  pleaseEnterTheAmountOfPenalty: '请输入惩罚金额',//请输入惩罚金额
  otherPenalties: '其他惩罚',//其他惩罚
  pleaseEnterOtherPenalties: '请输入其他惩罚',//请输入其他惩罚
  basicSurrogateFee: '基本代养费',//基本代养费
  marginBalance: '保证金余额',//保证金余额
  amountDue: '应付金额',//应付金额
  marginWithholding: '保证金扣缴',//保证金扣缴
  actualAmountPaid: '实付金额',//实付金额
  pleaseEnterTheAmountOfDepositWithholding: '请输入保证金扣缴金额',//请输入保证金扣缴金额
  settlementFormVerificationDidNotPass: '结算表单校验未通过',//结算表单校验未通过
  pleaseSelectTheDate: '请选择日期',//请选择日期
  pleaseEnterTheDailyPrice: '请输入每日价格',//请输入每日价格
  pleaseEnterTheNumber: '请输入编号',//请输入编号
  pleaseSelectTheStandardCycleIndexNumber: '请选择标准循环指标编号',//请选择标准循环指标编号
  pleaseEnterTheOrganAnatomyCategory: '请输入脏器解剖类别',//请输入脏器解剖类别
  pleaseEnterTheSymptomClassification: '请输入症状分类',//请输入症状分类
  farmName: '农场名称',//农场名称
  pleaseEnterTheNameOfTheFarm: '请输入农场名称',//请输入农场名称
  institutionType: '机构类型',//机构类型
  pleaseSelectTheTypeOfOrganization: '请选择机构类型',//请选择机构类型
  createABuilding: '创建栋舍',//创建栋舍
  pleaseChooseToCreateABuilding: '请选择创建栋舍',//请选择创建栋舍
  numberOfBuildings: '栋舍数',//栋舍数
  pleaseEnterTheNumberOfBuildings: '请输入栋舍数',//请输入栋舍数
  createWarehouse: '创建仓库',//创建仓库
  pleaseChooseToCreateAWarehouse: '请选择创建仓库',//请选择创建仓库
  permissionAssignment: '权限分配',//权限分配
  pleaseSelectUser: '请选择用户',//请选择用户
  pleaseSelectTheDrugWarehouse: '请选择药品仓库',//请选择药品仓库
  pleaseEnterTheWarehousingOrderNumber: '请输入入库单号',//请输入入库单号
  transferOutDepartment: '转出部门',//转出部门
  pleaseSelectTheTransferDepartment: '请选择转出部门',//请选择转出部门
  transferToDepartment: '转入部门',//转入部门
  pleaseSelectTheTransferDepartment: '请选择转入部门',//请选择转入部门
  date: '日期',//日期
  featherKg: '羽/KG',//羽/KG
  poultrySeedlings: '禽苗',//禽苗
  pleaseEnterPoultrySeedlings: '请输入禽苗',//请输入禽苗
  pleaseEnterAUsername: '请输入用户名!', // 请输入用户名!
  pleaseEnterAPassword: ' 请输入密码!', // 请输入密码!
  pleaseEnterTheVerificationCode: '请输入验证码!', // 请输入验证码!
  pleaseDragTheSlider: ' 请拖动滑块！', // 请拖动滑块！
  loginFailed: ' 登录失败', // 登录失败
  pleaseUseChrome: '请使用谷歌或者谷歌内核浏览器，否则相关功能将不能正常使用！ ', // 请使用谷歌或者谷歌内核浏览器，否则相关功能将不能正常使用！
  costItemCode: ' 成本项编号', // 成本项编号
  costItemName: ' 成本项名称', // 成本项名称
  pleaseEnterCostItemCode: ' 请输入成本项编号', // 请输入成本项编号
  pleaseEntercostItemName: ' 请输入成本项名称', // 请输入成本项名称
  generateVoucher: '生成凭证',//生成凭证
  syncVoucher: '同步凭证',//同步凭证
  reverseVoucher: '冲销凭证',//冲销凭证
  selectVoucher: '凭证选择',//凭证选择
  extractMaterialCost: '生产成本提取',//生产成本提取
  extractOverhead: '制造费用提取',//制造费用提取
  extractStockVariance: '存栏变动提取',//存栏变动提取
  allocateMaterialCost: '生产成本分摊',//生产成本分摊
  allocateOverhead: '制造费用分摊',//制造费用分摊
  allocateCatchCost: '出栏成本分摊',//出栏成本分摊
  tongbuyewuleixing: '同步业务类型', //同步业务类型
  taskName: '任务类名', //任务类名
  cronExpression: 'cron表达式', //cron表达式
  args: '参数', //参数
  pleaseChooseTaskName: '请输入任务类名', //任务类名
  pleaseEnterArgs: '请输入参数', //请输入参数
  taskStatus: '任务状态', //任务状态
  all: '全部', //全部
  start: '启动',
  stop: '停止', //停止
  started: '已启动', //已启动
  paused: '已暂停', //已暂停
  executeImmediately: '立即执行', //立即执行
  saveAndScheduleTasks: '保存并安排任务', //保存并安排任务
  applicableBusiness: '适用业务', //适用业务
  pleaseChooseApplicableBusiness: '请选择适用业务' //请选择适用业务
}